const countries = {
  US: 'United States',
  UK: 'United Kingdom',
  AF: 'Afghanistan',
  AL: 'Albania',
  DZ: 'Algeria',
  AD: 'Andorra',
  AO: 'Angola',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BA: 'Bosnia And Herzegovina',
  BW: 'Botswana',
  BR: 'Brazil',
  BN: 'Brunei',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Cabo Verde',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CL: 'Chile',
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CI: "Cote d'Ivoire",
  HR: 'Croatia',
  CU: 'Cuba',
  CY: 'Cyprus',
  CZ: 'Czechia',
  CD: 'Democratic Republic of the Congo',
  DK: 'Denmark',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  EE: 'Estonia',
  SZ: 'Eswatini',
  ET: 'Ethiopia',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GA: 'Gabon',
  GM: 'The Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GR: 'Greece',
  GD: 'Grenada',
  GN: 'Guinea',
  GT: 'Guatemala',
  HT: 'Haiti',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran',
  IQ: 'Iraq',
  IE: 'Ireland',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  XK: 'Kosovo',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: 'Laos',
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MR: 'Mauritania',
  MU: 'Mauritius',
  MX: 'Mexico',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar (Burma)',
  NA: 'Namibia',
  NP: 'Nepal',
  NL: 'Netherlands',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  MK: 'North Macedonia',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PS: 'Palestine',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  CG: 'Republic of the Congo',
  RO: 'Romania',
  RU: 'Russia',
  RW: 'Rwanda',
  LC: 'Saint Lucia',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SO: 'Somalia',
  ZA: 'South Africa',
  KR: 'South Korea',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syria',
  TW: 'Taiwan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  BS: 'The Bahamas',
  TG: 'Togo',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VE: 'Venezuela',
  VN: 'Vietnam',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
};

const citiesByCountries = {
  US: [
    'Abbeyville',
    'Aberdeen',
    'Abilene',
    'Acton',
    'Acworth',
    'Addison',
    'Adrian',
    'Agoura Hills',
    'Aiken',
    'Air Force Academy',
    'Akron',
    'Akwesasne',
    'Alameda',
    'Albany',
    'Albuquerque',
    'Aldie',
    'Alexandria',
    'Algonquin',
    'Alhambra',
    'Aliso Viejo',
    'Allen',
    'Allendale Charter Township',
    'Allentown',
    'Alliance',
    'Alpharetta',
    'Alpine',
    'Alsip',
    'Altamonte Springs',
    'Altoona',
    'Amarillo',
    'America City',
    'American Canyon',
    'American Fork',
    'Americus',
    'Ames',
    'Amherst',
    'Amityville',
    'Amsterdam',
    'Anaheim',
    'Anchorage',
    'Anderson',
    'Andover',
    'Ankeny',
    'Ann Arbor',
    'Anna',
    'Annandale',
    'Annapolis',
    'Anniston',
    'Anselmo',
    'Antioch',
    'Apex',
    'Apollo Beach',
    'Apopka',
    'Apple Valley',
    'Appleton',
    'Aptos',
    'Arcadia',
    'Arcata',
    'Ardmore',
    'Ardsley',
    'Arizona City',
    'Arlington',
    'Arlington Heights',
    'Arvada',
    'Asbury Park',
    'Ashburn',
    'Asheboro',
    'Asheville',
    'Ashland',
    'Ashley',
    'Atascadero',
    'Athens',
    'Atlanta',
    'Atlantic City',
    'Attleboro',
    'Aubrey',
    'Auburn',
    'Augusta',
    'Aurora',
    'Austell',
    'Austin',
    'Aventura',
    'Avon',
    'Avon Park',
    'Avondale',
    'Avondale Estates',
    'Ayer',
    'Aztec',
    'Backus',
    'Bainbridge Island',
    'Bakersfield',
    'Ballwin',
    'Baltimore',
    'Bangor',
    'Barberton',
    'Barstow',
    'Bartlett',
    'Bartow',
    'Basehor',
    'Basking Ridge',
    'Batavia',
    'Baton Rouge',
    'Battle Creek',
    'Bay City',
    'Bay Shore',
    'Bayonne',
    'Baytown',
    'Beacon',
    'Bear',
    'Beaumont',
    'Beavercreek',
    'Beaverton',
    'Bedford',
    'Bel Air',
    'Bel Air North',
    'Belchertown',
    'Bell Gardens',
    'Belleville',
    'Bellevue',
    'Bellflower',
    'Bellingham',
    'Bellmawr',
    'Bellmore',
    'Bellport',
    'Belmont',
    'Beloit',
    'Beltsville',
    'Bend',
    'Benicia',
    'Bensalem',
    'Bentonville',
    'Berea',
    'Berkeley',
    'Berkeley Township',
    'Berkley',
    'Berlin',
    'Berwick',
    'Berwyn',
    'Bethel',
    'Bethesda',
    'Bethlehem',
    'Beulah',
    'Beverly',
    'Beverly Hills',
    'Biddeford',
    'Big Rapids',
    'Bigfork',
    'Billerica',
    'Billings',
    'Biloxi',
    'Binghamton',
    'Birmingham',
    'Bismarck',
    'Blacklick',
    'Blacksburg',
    'Blaine',
    'Blanchester',
    'Bloomfield',
    'Bloomfield Hills',
    'Bloomingdale',
    'Bloomington',
    'Blue Bell',
    'Blue Springs',
    'Bluefield',
    'Bluffton',
    'Blythewood',
    'Boca Raton',
    'Boerne',
    'Bogalusa',
    'Boise',
    'Bolingbrook',
    'Bon Air',
    'Bonita Springs',
    'Bonney Lake',
    'Booker',
    'Boon',
    'Boone',
    'Boonton',
    'Bossier City',
    'Boston',
    'Bothell',
    'Boulder',
    'Bound Brook',
    'Bountiful',
    'Bowie',
    'Bowling Green',
    'Boynton Beach',
    'Bozeman',
    'Bradenton',
    'Branchville',
    'Brandon',
    'Brandywine',
    'Branson',
    'Brea',
    'Bremerton',
    'Brentwood',
    'Brick Township',
    'Bridgeport',
    'Bridgewater',
    'Brighton',
    'Bristol',
    'Broadlands',
    'Brockton',
    'Broken Arrow',
    'Brookfield',
    'Brookline',
    'Brooklyn',
    'Brooklyn Park',
    'Brooksville',
    'Brookville',
    'Broomfield',
    'Brownsville',
    'Brunswick',
    'Bryan',
    'Bryn Athyn',
    'Buckeye',
    'Buena Park',
    'Buena Vista',
    'Buffalo',
    'Buford',
    'Bunker Hill',
    'Burbank',
    'Burlingame',
    'Burlington',
    'Burnsville',
    'Butler',
    'Butte',
    'Cadillac',
    'Calabasas',
    'Caldwell',
    'Calexico',
    'California City',
    'Camarillo',
    'Cambridge',
    'Camden',
    'Camp Hill',
    'Campbell',
    'Canandaigua',
    'Canby',
    'Canton',
    'Cape Coral',
    'Cape Girardeau',
    'Capitol Heights',
    'Captain Cook',
    'Carbondale',
    'Carlsbad',
    'Carmel',
    'Carmel Hamlet',
    'Carmichael',
    'Carol Stream',
    'Carolina Beach',
    'Carrboro',
    'Carrollton',
    'Carson',
    'Carson City',
    'Cary',
    'Casa Grande',
    'Casper',
    'Casselberry',
    'Castaic',
    'Castle Rock',
    'Castro Valley',
    'Catalina Foothills',
    'Catonsville',
    'Cazenovia',
    'Cedar City',
    'Cedar Falls',
    'Cedar Grove',
    'Cedar Park',
    'Cedar Rapids',
    'Cedarburg',
    'Centennial',
    'Centerport',
    'Centerville',
    'Centralia',
    'Centreville',
    'Chadds Ford',
    'Chamblee',
    'Champaign',
    'Chandler',
    'Chanhassen',
    'Chantilly',
    'Chapel Hill',
    'Chappaqua',
    'Charles Town',
    'Charleston',
    'Charlotte',
    'Charlottesville',
    'Chaska',
    'Chatham',
    'Chattanooga',
    'Chelmsford',
    'Cheltenham',
    'Cheney',
    'Cherry Hill',
    'Chesapeake',
    'Cheshire',
    'Chester',
    'Chesterfield',
    'Chesterton',
    'Cheyenne',
    'Chicago',
    'Chickasha',
    'Chico',
    'Chino',
    'Chino Hills',
    'Christiansburg',
    'Chula Vista',
    'Cicero',
    'Cincinnati',
    'Citrus Heights',
    'City of Industry',
    'Claremont',
    'Clarksburg',
    'Clarkston',
    'Clarksville',
    'Clawson',
    'Clayton',
    'Clear Lake',
    'Clearwater',
    'Clemson',
    'Clermont',
    'Cleveland',
    'Cleveland Heights',
    'Clifton',
    'Clifton Park',
    'Clinton',
    'Clinton Township',
    'Clovis',
    'Clyde',
    'Coatesville',
    'Cocoa',
    'Coconut Creek',
    "Coeur d'Alene",
    'Colfax',
    'Collbran',
    'College Park',
    'College Station',
    'Collierville',
    'Collingswood',
    'Collinsville',
    'Colonie',
    'Colorado City',
    'Colorado Springs',
    'Columbia',
    'Columbus',
    'Commack',
    'Commerce Charter Township',
    'Compton',
    'Concord',
    'Conrad',
    'Conroe',
    'Conshohocken',
    'Converse',
    'Conway',
    'Conyers',
    'Cooper City',
    'Coos Bay',
    'Coppell',
    'Coral Gables',
    'Coral Springs',
    'Coram',
    'Cornelius',
    'Corning',
    'Corona',
    'Corpus Christi',
    'Cortland',
    'Corvallis',
    'Corydon',
    'Costa Mesa',
    'Council Bluffs',
    'Covina',
    'Covington',
    'Coweta',
    'Cranford',
    'Cranston',
    'Crestview',
    'Crete',
    'Cross Plains',
    'Croton-on-Hudson',
    'Crowley',
    'Crown Point',
    'Crystal Lake',
    'Crystal River',
    'Culver City',
    'Cumming',
    'Cupertino',
    'Cutler Bay',
    'Cuyahoga Falls',
    'Cypress',
    'Dacula',
    'Dallas',
    'Dalton',
    'Daly City',
    'Danbury',
    'Dane',
    'Danville',
    'Darien',
    'Davenport',
    'Davie',
    'Davis',
    'Dawsonville',
    'Dayton',
    'Daytona Beach',
    'Dearborn',
    'Decatur',
    'Deer Creek',
    'Deerfield Beach',
    'DeKalb',
    'Del Rey',
    'DeLand',
    'Delano',
    'Delaware City',
    'Delhi',
    'Delray Beach',
    'Deltona',
    'Denison',
    'Denton',
    'Denver',
    'Denville',
    'Deptford',
    'Derby',
    'Des Moines',
    'Des Plaines',
    'Desert Hot Springs',
    'Destin',
    'Detroit',
    'Detroit Lakes',
    'Dillon',
    'Dillwyn',
    'Dix Hills',
    'Dobbs Ferry',
    'Doral',
    'Dothan',
    'Douglas',
    'Douglasville',
    'Dover',
    'Downers Grove',
    'Downey',
    'Downingtown',
    'Doylestown',
    'Draper',
    'Dripping Springs',
    'Dublin',
    'Dubuque',
    'Duluth',
    'Dumfries',
    'Duncan',
    'Duncanville',
    'Dunwoody',
    'Durango',
    'Durham',
    'Dwight',
    'Eagan',
    'Eagle',
    'Eagle Mountain',
    'Earth',
    'Easley',
    'East Aurora',
    'East Bridgewater',
    'East Brunswick',
    'East Haddam',
    'East Lansing',
    'East Los Angeles',
    'East Northport',
    'East Orange',
    'East Rutherford',
    'East Stroudsburg',
    'East Syracuse',
    'Easton',
    'Eastvale',
    'Eatontown',
    'Eau Claire',
    'Eden Prairie',
    'Edgar Springs',
    'Edgewater',
    'Edina',
    'Edinburg',
    'Edison',
    'Edmond',
    'Edmonds',
    'Edwards',
    'Edwardsville',
    'Effingham',
    'Egg Harbor Township',
    'Egypt Lake-Leto',
    'El Cajon',
    'El Centro',
    'El Monte',
    'El Paso',
    'El Segundo',
    'El Sobrante',
    'Elbridge',
    'Elgin',
    'Elizabeth',
    'Elizabethtown',
    'Elk Grove',
    'Elkhart',
    'Elkhorn',
    'Ellensburg',
    'Ellenville',
    'Ellenwood',
    'Ellicott City',
    'Elmhurst',
    'Elmont',
    'Elmwood Park',
    'Elwood',
    'Elyria',
    'Emeryville',
    'Encinitas',
    'Enfield',
    'Englewood',
    'Ennis',
    'Enterprise',
    'Ephrata',
    'Erie',
    'Escondido',
    'Essex',
    'Estero',
    'Eugene',
    'Euless',
    'Eureka',
    'Evans',
    'Evanston',
    'Evansville',
    'Everett',
    'Evesham',
    'Ewa Villages',
    'Excelsior',
    'Exeter',
    'Fair Lawn',
    'Fair Oaks',
    'Fairborn',
    'Fairfax',
    'Fairfield',
    'Fairmont',
    'Fairview',
    'Fall River',
    'Falls Church',
    'Falmouth',
    'Fargo',
    'Faribault',
    'Farmingdale',
    'Farmington',
    'Farmington Hills',
    'Farmingville',
    'Fayetteville',
    'Feasterville-Trevose',
    'Federal Way',
    'Fenton',
    'Ferndale',
    'Fife',
    'Fishers',
    'Fitchburg',
    'Flagler Beach',
    'Flagstaff',
    'Flat Rock',
    'Flemington',
    'Flint',
    'Florence',
    'Florida',
    'Florida City',
    'Florissant',
    'Flossmoor',
    'Flower Mound',
    'Flowery Branch',
    'Folsom',
    'Fontana',
    'Forest',
    'Forney',
    'Fort Collins',
    'Fort Lauderdale',
    'Fort Lee',
    'Fort Leonard Wood',
    'Fort Mill',
    'Fort Myers',
    'Fort Pierce',
    'Fort Plain',
    'Fort Smith',
    'Fort Walton Beach',
    'Fort Washington',
    'Fort Wayne',
    'Fort Worth',
    'Fountain Inn',
    'Fountain Valley',
    'Fox Point',
    'Foxborough',
    'Framingham',
    'Frankfort',
    'Franklin',
    'Franklin Township',
    'Frederick',
    'Fredericksburg',
    'Fredonia',
    'Freehold',
    'Freehold Township',
    'Freeport',
    'Fremont',
    'Fresno',
    'Frisco',
    'Front Royal',
    'Frostproof',
    'Fullerton',
    'Fulton',
    'Fuquay-Varina',
    'Gaffney',
    'Gainesville',
    'Gaithersburg',
    'Gallatin',
    'Galloway',
    'Galveston',
    'Gambrills',
    'Garden City',
    'Garden Grove',
    'Garden Valley',
    'Gardena',
    'Garland',
    'Garner',
    'Gaston',
    'Gastonia',
    'Gate City',
    'Gatesville',
    'Geneva',
    'Georgetown',
    'Germantown',
    'Gig Harbor',
    'Gilbert',
    'Gilberts',
    'Gilroy',
    'Glassboro',
    'Glen Allen',
    'Glen Arm',
    'Glen Cove',
    'Glen Ellyn',
    'Glen Mills',
    'Glendale',
    'Glendora',
    'Glenn Heights',
    'Glenview',
    'Glenwood Springs',
    'Globe',
    'Gloucester Township',
    'Godley',
    'Golden',
    'Golden Valley',
    'Goldsboro',
    'Gonzales',
    'Goodlettsville',
    'Gordon',
    'Gorham',
    'Goshen',
    'Graham',
    'Granbury',
    'Granby',
    'Grand Blanc',
    'Grand Island',
    'Grand Junction',
    'Grand Prairie',
    'Grand Rapids',
    'Granite Bay',
    'Grants Pass',
    'Grantsville',
    'Grapevine',
    'Grass Valley',
    'Grayslake',
    'Great Barrington',
    'Great Falls',
    'Greeley',
    'Green Bay',
    'Green Valley',
    'Greenbelt',
    'Greenfield',
    'Greensboro',
    'Greensburg',
    'Greenville',
    'Greenwich',
    'Greenwood',
    'Greenwood Village',
    'Greer',
    'Gresham',
    'Griffin',
    'Groton',
    'Groveport',
    'Gulfport',
    'Guttenberg',
    'Guyton',
    'Hacienda Heights',
    'Hackensack',
    'Hacker Valley',
    'Hackettstown',
    'Hagerstown',
    'Hallandale Beach',
    'Hamburg',
    'Hamden',
    'Hamilton',
    'Hamilton Township',
    'Hammond',
    'Hampden',
    'Hampstead',
    'Hampton',
    'Hanford',
    'Hanover',
    'Hanover Park',
    'Hansville',
    'Harlan',
    'Harlingen',
    'Harrisburg',
    'Harrison',
    'Harrisonburg',
    'Hartford',
    'Harwinton',
    'Hastings',
    'Hatboro',
    'Hattiesburg',
    'Haverhill',
    'Havertown',
    'Hawthorne',
    'Hayward',
    'Helena',
    'Hemet',
    'Hempstead',
    'Henderson',
    'Hendersonville',
    'Henrico',
    'Hephzibah',
    'Herculaneum',
    'Hermosa Beach',
    'Herndon',
    'Hesperia',
    'Hialeah',
    'Hiawassee',
    'Hickory',
    'Hicksville',
    'High Falls',
    'High Point',
    'High Rolls',
    'Highland',
    'Highland Park',
    'Highlands Ranch',
    'Hilliard',
    'Hillsboro',
    'Hillsborough Township',
    'Hillsdale',
    'Hillside',
    'Hilo',
    'Hinesville',
    'Hingham',
    'Hoboken',
    'Hoffman Estates',
    'Holbrook',
    'Holland',
    'Hollister',
    'Holly Springs',
    'Hollywood',
    'Holyoke',
    'Homer',
    'Homestead',
    'Homewood',
    'Honesdale',
    'Honolulu',
    'Hood River',
    'Hoover',
    'Hopatcong',
    'Hopewell',
    'Hopewell Junction',
    'Hot Springs',
    'Houma',
    'Houston',
    'Howell',
    'Hudson',
    'Hudson Falls',
    'Hull',
    'Humble',
    'Hummelstown',
    'Hunlock Creek',
    'Huntersville',
    'Huntington',
    'Huntington Beach',
    'Huntington Park',
    'Huntley',
    'Huntsville',
    'Hyattsville',
    'Idaho Falls',
    'Illinois City',
    'Independence',
    'India Hook',
    'Indian Creek',
    'Indian River',
    'Indian Rocks Beach',
    'Indian Trail',
    'Indian Wells',
    'Indianapolis',
    'Indianola',
    'Indio',
    'Inglewood',
    'Inman',
    'Iowa City',
    'Irvine',
    'Irving',
    'Irvington',
    'Issaquah',
    'Ithaca',
    'Jackson',
    'Jackson Township',
    'Jacksonville',
    'Jamaica',
    'Jamestown',
    'Janesville',
    'Jefferson',
    'Jefferson City',
    'Jenks',
    'Jersey City',
    'Johns Creek',
    'Johnson City',
    'Johnstown',
    'Joliet',
    'Jonesboro',
    'Joplin',
    'Joshua Tree',
    'Juniata',
    'Jupiter',
    'Kailua-Kona',
    'Kalamazoo',
    'Kalispell',
    'Kaneohe',
    'Kannapolis',
    'Kansas City',
    'Kapaau',
    'Kapaa',
    'Kapolei',
    'Katy',
    'Kaysville',
    'Kearney',
    'Kearny',
    'Keene',
    'Keller',
    'Kenner',
    'Kennesaw',
    'Kennewick',
    'Kenosha',
    'Kensington',
    'Kent',
    'Kentwood',
    'Kernersville',
    'Kerrville',
    'Key West',
    'Keystone',
    'Kihei',
    'Kilgore',
    'Killeen',
    'King',
    'King George',
    'King of Prussia',
    'Kingman',
    'Kings Park',
    'Kingsport',
    'Kingston',
    'Kirkland',
    'Kissimmee',
    'Kittery',
    'Knoxville',
    'Kokomo',
    'Kula',
    'Kutztown',
    'Kyle',
    'La Crosse',
    'La Habra',
    'La Mesa',
    'La Porte',
    'La Puente',
    'Lacey Township',
    'Lafayette',
    'Lafayette Hill',
    'LaGrange',
    'Laguna Beach',
    'Laguna Hills',
    'Laguna Niguel',
    'Lake Bluff',
    'Lake Charles',
    'Lake City',
    'Lake Elsinore',
    'Lake Forest',
    'Lake Mary',
    'Lake Oswego',
    'Lake Stevens',
    'Lake Wales',
    'Lake Worth Beach',
    'Lake Zurich',
    'Lakeland',
    'Lakeville',
    'Lakeway',
    'Lakewood',
    'Lambertville',
    'Lancaster',
    "Land O' Lakes",
    'Lanham',
    'Lansdale',
    'Lansdowne',
    'Lansing',
    'Laramie',
    'Laredo',
    'Largo',
    'Las Cruces',
    'Las Vegas',
    'Lathrop',
    'Lauderhill',
    'Laurel',
    'Lawrence',
    'Lawrenceburg',
    'Lawrenceville',
    'Lawton',
    'Layton',
    'League City',
    'Leander',
    'Leawood',
    'Lebanon',
    "Lee's Summit",
    'Leesburg',
    'Lehi',
    'Lehigh Acres',
    'Leland',
    'Lenexa',
    'Leominster',
    'Lester',
    'Levittown',
    'Lewes',
    'Lewiston',
    'Lewisville',
    'Lexington',
    'Lilburn',
    'Lincoln',
    'Linden',
    'Lindenhurst',
    'Lithia',
    'Lithonia',
    'Lititz',
    'Little Elm',
    'Little River',
    'Little Rock',
    'Littlestown',
    'Littleton',
    'Livermore',
    'Liverpool',
    'Livonia',
    'Lodi',
    'Logan',
    'Loganville',
    'Loma Linda',
    'Londonderry',
    'Long Beach',
    'Longmont',
    'Longview',
    'Lorena',
    'Lorton',
    'Los Alamitos',
    'Los Angeles',
    'Los Gatos',
    'Louisville',
    'Loveland',
    'Lowell',
    'Loxahatchee Groves',
    'Lubbock',
    'Lufkin',
    'Lumberton',
    'Lutz',
    'Lyman',
    'Lynchburg',
    'Lyndhurst',
    'Lynn',
    'Lynnwood',
    'Lynwood',
    'Mabank',
    'Mableton',
    'Macedonia',
    'Macomb',
    'Macon',
    'Madison',
    'Magnolia',
    'Mahwah',
    'Maitland',
    'Malden',
    'Malibu',
    'Malvern',
    'Mamaroneck',
    'Manalapan Township',
    'Manassas',
    'Manchester',
    'Manhasset',
    'Manhattan',
    'Manhattan Beach',
    'Mankato',
    'Manlius',
    'Manor',
    'Mansfield',
    'Manteca',
    'Maple Grove',
    'Maple Valley',
    'Mapleton',
    'Maplewood',
    'Margate',
    'Marianna',
    'Maricopa',
    'Marietta',
    'Marina',
    'Marina del Rey',
    'Marion',
    'Marlboro',
    'Marlboro Township',
    'Marlborough',
    'Marquette',
    'Marshall',
    'Martinez',
    'Martinsburg',
    'Marysville',
    'Mason',
    'Massapequa',
    'Massillon',
    'Matawan',
    'Matthews',
    'Maywood',
    'McAllen',
    'McCall',
    'McDonough',
    'McKinney',
    'McLean',
    'McMinnville',
    'McPherson',
    'Meadville',
    'Mechanicsburg',
    'Medfield',
    'Medford',
    'Media',
    'Medina',
    'Melbourne',
    'Melissa',
    'Melrose',
    'Memphis',
    'Menifee',
    'Menlo Park',
    'Menomonie',
    'Mentor',
    'Mequon',
    'Mercer Island',
    'Meredith',
    'Meriden',
    'Meridian',
    'Merrick',
    'Merrimac',
    'Mesa',
    'Mesquite',
    'Metairie',
    'Mexican Hat',
    'Miami',
    'Miami Beach',
    'Miami Gardens',
    'Miami Lakes',
    'Michigan City',
    'Middleton',
    'Middletown',
    'Middletown Township',
    'Midland',
    'Midlothian',
    'Midwest',
    'Milford',
    'Milford Charter Township',
    'Mill Valley',
    'Millersville',
    'Millington',
    'Millville',
    'Milpitas',
    'Milton',
    'Milwaukee',
    'Milwaukie',
    'Mineola',
    'Minneapolis',
    'Minnetonka',
    'Miramar',
    'Mishawaka',
    'Mission',
    'Mission Viejo',
    'Missoula',
    'Missouri City',
    'Mobile',
    'Modesto',
    'Mokena',
    'Moline',
    'Monroe',
    'Monroe Township',
    'Monroeville',
    'Monrovia',
    'Montclair',
    'Montebello',
    'Monterey',
    'Monterey Park',
    'Montgomery',
    'Montgomery Village',
    'Moore',
    'Mooresville',
    'Moorpark',
    'Moreno Valley',
    'Morgan Hill',
    'Morgantown',
    'Morris Plains',
    'Morristown',
    'Morrisville',
    'Morrow',
    'Mount Airy',
    'Mount Dora',
    'Mount Holly',
    'Mount Hope',
    'Mount Laurel Township',
    'Mount Pleasant',
    'Mount Prospect',
    'Mount Vernon',
    'Mountain City',
    'Mountain View',
    'Mountlake Terrace',
    'Mt. Juliet',
    'Muncie',
    'Murfreesboro',
    'Murray',
    'Murrieta',
    'Muskegon',
    'Myrtle Beach',
    'Myrtle Point',
    'Nacogdoches',
    'Nampa',
    'Napa',
    'Naperville',
    'Naples',
    'Narragansett',
    'Nashua',
    'Nashville',
    'Natick',
    'Naugatuck',
    'Nebraska City',
    'Needham',
    'Neenah',
    'Neptune City',
    'Nevada City',
    'New Albany',
    'New Bedford',
    'New Berlin',
    'New Bern',
    'New Braunfels',
    'New Brighton',
    'New Britain',
    'New Brunswick',
    'New Castle',
    'New City',
    'New Haven',
    'New Hyde Park',
    'New Lenox',
    'New London',
    'New Milford',
    'New Orleans',
    'New Paltz',
    'New Philadelphia',
    'New Port Richey',
    'New Providence',
    'New Rochelle',
    'New Smyrna Beach',
    'New Windsor',
    'New York',
    'New York City',
    'New York Mills',
    'Newark',
    'Newberg',
    'Newburgh',
    'Newburyport',
    'Newington',
    'Newnan',
    'Newport',
    'Newport Beach',
    'Newport News',
    'Newton',
    'Newtown',
    'Niagara Falls',
    'Nicholasville',
    'Niles',
    'Niverville',
    'Noblesville',
    'Norcross',
    'Norfolk',
    'Normal',
    'Norman',
    'Norristown',
    'North Andover',
    'North Augusta',
    'North Bergen',
    'North Brunswick Township',
    'North Canton',
    'North Charleston',
    'North Haven',
    'North Kingstown',
    'North Las Vegas',
    'North Little Rock',
    'North Miami',
    'North Miami Beach',
    'North Olmsted',
    'North Plainfield',
    'North Port',
    'North Richland Hills',
    'North Versailles',
    'Northampton',
    'Northfield',
    'Northport',
    'Northville',
    'Norton',
    'Norwalk',
    'Norwood',
    'Novato',
    'Novi',
    'Nutley',
    "O'fallon",
    'Oak Creek',
    'Oak Harbor',
    'Oak Lawn',
    'Oak Park',
    'Oakdale',
    'Oakland',
    'Oakland Park',
    'Ocala',
    'Ocean City',
    'Ocean Springs',
    'Ocean Township',
    'Oceanside',
    'Ocoee',
    'Oconomowoc',
    'Odenton',
    'Odessa',
    'Ogden',
    'Ohio City',
    'Ojai',
    'Oklahoma City',
    'Olathe',
    'Old Bridge',
    'Olympia',
    'Olyphant',
    'Omaha',
    'Ontario',
    'Opelika',
    'Opelousas',
    'Orange',
    'Orange Park',
    'Orangeburg',
    'Orem',
    'Orient',
    'Orland Park',
    'Orlando',
    'Oshkosh',
    'Ossining',
    'Oswego',
    'Overland Park',
    'Oviedo',
    'Owatonna',
    'Owings Mills',
    'Oxford',
    'Oxnard',
    'Ozark',
    'Pacifica',
    'Painesville',
    'Palatine',
    'Palisades Park',
    'Palm Bay',
    'Palm Beach',
    'Palm Beach Gardens',
    'Palm Coast',
    'Palm Desert',
    'Palm Harbor',
    'Palm Springs',
    'Palmdale',
    'Palmetto',
    'Palmview',
    'Palo Alto',
    'Panama City',
    'Paramount',
    'Paramus',
    'Park City',
    'Parker',
    'Parkersburg',
    'Parkland',
    'Parkville',
    'Parma',
    'Parrish',
    'Parsippany-Troy Hills',
    'Parsons',
    'Pasadena',
    'Passaic',
    'Patchogue',
    'Paterson',
    'Pawtucket',
    'Pea Ridge',
    'Peachtree City',
    'Peachtree Corners',
    'Pearisburg',
    'Pearland',
    'Peekskill',
    'Pelham',
    'Pelham Manor',
    'Pembroke Pines',
    'Pennsauken Township',
    'Pensacola',
    'Peoria',
    'Perkasie',
    'Perry',
    'Perrysburg',
    'Perth Amboy',
    'Petaluma',
    'Petersburg',
    'Pflugerville',
    'Pharr',
    'Philadelphia',
    'Phillipsburg',
    'Phoenix',
    'Phoenixville',
    'Piedmont',
    'Pineville',
    'Piscataway',
    'Pittsboro',
    'Pittsburg',
    'Pittsburgh',
    'Pittsfield',
    'Pittsgrove',
    'Placentia',
    'Placida',
    'Plainfield',
    'Plainsboro Township',
    'Plainview',
    'Plano',
    'Plantation',
    'Plaucheville',
    'Pleasant Grove',
    'Pleasant Hill',
    'Pleasanton',
    'Pleasantville',
    'Plum',
    'Plymouth',
    'Pocatello',
    'Point Marion',
    'Point Pleasant',
    'Pomona',
    'Pompano Beach',
    'Ponca City',
    'Ponte Vedra Beach',
    'Pontiac',
    'Pooler',
    'Port Arthur',
    'Port Charlotte',
    'Port Jefferson',
    'Port Orange',
    'Port Orchard',
    'Port St. Lucie',
    'Portage',
    'Portland',
    'Portsmouth',
    'Post Falls',
    'Potomac',
    'Pottstown',
    'Potwin',
    'Poughkeepsie',
    'Poulsbo',
    'Powder Springs',
    'Prescott',
    'Prescott Valley',
    'PRETTY PRAIRE',
    'Princeton',
    'Prosper',
    'Providence',
    'Provo',
    'Pueblo',
    'Pulaski',
    'Pullman',
    'Punta Gorda',
    'Putnam',
    'Puyallup',
    'Queen Creek',
    'Queens',
    'Queensbury',
    'Quincy',
    'Racine',
    'Radford',
    'Raleigh',
    'Ramona',
    'Rancho Cordova',
    'Rancho Cucamonga',
    'Rancho Mirage',
    'Rancho Palos Verdes',
    'Rancho Santa Margarita',
    'Randallstown',
    'Randolph',
    'Rapid City',
    'Reading',
    'Red Bank',
    'Red Hook',
    'Red Lion',
    'Red Oak',
    'Redding',
    'Redlands',
    'Redmond',
    'Redondo Beach',
    'Redwood City',
    'Reidsville',
    'Reisterstown',
    'Remote',
    'Reno',
    'Renton',
    'Reston',
    'Revere',
    'Rexburg',
    'Rialto',
    'Richardson',
    'Richboro',
    'Richfield',
    'Richland',
    'Richmond',
    'Ridgefield',
    'Ridgefield Park',
    'Ridgeland',
    'Ridgeway',
    'Ridgewood',
    'Rio Rancho',
    'Rio Verde',
    'Ripon',
    'River Edge',
    'Riverdale',
    'Riverhead',
    'Riverside',
    'Riverview',
    'Roanoke',
    'Rochester',
    'Rochester Hills',
    'Rock Hill',
    'Rockford',
    'Rocklin',
    'Rockville',
    'Rockville Centre',
    'Rockwall',
    'Rocky Hill',
    'Rocky Mount',
    'Rocky River',
    'Rogers',
    'Rohnert Park',
    'Rolla',
    'Romeoville',
    'Romulus',
    'Ronkonkoma',
    'Roseburg',
    'Roselle',
    'Roseville',
    'Roswell',
    'Round Rock',
    'Rowland Heights',
    'Royal Oak',
    'Royal Palm Beach',
    'Royersford',
    'Ruidoso',
    'Rumford',
    'Ruskin',
    'Russellville',
    'Rutherford',
    'Sacramento',
    'Saginaw',
    'Sahuarita',
    'Saint Albans',
    'Saint Charles',
    'Saint Clair',
    'Saint Johns',
    'Saint Joseph',
    'Saint Louis',
    'Saint Paul',
    'Saint Petersburg',
    'Salem',
    'Salem Lakes',
    'Salinas',
    'Salisbury',
    'Salt Lake City',
    'Sammamish',
    'San Angelo',
    'San Anselmo',
    'San Antonio',
    'San Bernardino',
    'San Bruno',
    'San Carlos',
    'San Clemente',
    'San Diego',
    'San Francisco',
    'San Gabriel',
    'San Jacinto',
    'San Jose',
    'San Juan Capistrano',
    'San Leandro',
    'San Luis Obispo',
    'San Marcos',
    'San Mateo',
    'San Rafael',
    'San Ramon',
    'San Tan Valley',
    'Sandpoint',
    'Sandusky',
    'Sandy',
    'Sandy Springs',
    'Sanford',
    'Sanger',
    'Santa Ana',
    'Santa Barbara',
    'Santa Clara',
    'Santa Clarita',
    'Santa Cruz',
    'Santa Fe',
    'Santa Monica',
    'Santa Rosa',
    'Santaquin',
    'Sarasota',
    'Saratoga',
    'Saratoga Springs',
    'Satellite Beach',
    'Saugerties',
    'Sausalito',
    'Savannah',
    'Saylorsburg',
    'Sayreville',
    'Scarsdale',
    'Schaumburg',
    'Schenectady',
    'Schertz',
    'Scotts Valley',
    'Scottsdale',
    'Scranton',
    'Searcy',
    'SeaTac',
    'Seattle',
    'Sebastopol',
    'Sebring',
    'Secaucus',
    'Seguin',
    'Selden',
    'Seminole',
    'Senatobia',
    'Setauket- East Setauket',
    'Severn',
    'Seymour',
    'Shaker Heights',
    'Sharon',
    'Shawnee',
    'Sheboygan',
    'Shelburne',
    'Shelby',
    'Shelbyville',
    'Shelton',
    'Sheridan',
    'Sherman',
    'Shreveport',
    'Shrewsbury',
    'Silver Spring',
    'Silver Springs',
    'Simi Valley',
    'Simla',
    'Simpsonville',
    'Sioux City',
    'Sioux Falls',
    'Sisters',
    'Skiatook',
    'Skokie',
    'Slidell',
    'Smithfield',
    'Smithtown',
    'Smyrna',
    'Snellville',
    'Snohomish',
    'Solana Beach',
    'Soldier',
    'Solon',
    'Somerville',
    'Sonoma',
    'South Amboy',
    'South Bend',
    'South Brunswick Township',
    'South Burlington',
    'South Euclid',
    'South Fulton',
    'South Gate',
    'South Hill',
    'South Jordan',
    'South Orange',
    'South Pasadena',
    'South Portland',
    'South San Francisco',
    'Southampton',
    'Southern Pines',
    'Southfield',
    'Southgate',
    'Southington',
    'Spanish Fork',
    'Sparks',
    'Sparta',
    'Spartanburg',
    'Spearfish',
    'Spencer',
    'Spokane',
    'Spokane Valley',
    'Spring',
    'Spring Hill',
    'Spring Valley',
    'Springdale',
    'Springfield',
    'Springville',
    'St. Augustine',
    'St. Charles',
    'St. Cloud',
    'St. George',
    'St. Louis',
    'St. Louis Park',
    'St. Peters',
    'St. Petersburg',
    'Stafford',
    'Stamford',
    'Stanford',
    'Stanhope',
    'Stanton',
    'Starkville',
    'State College',
    'Statesboro',
    'Staunton',
    'Stephens City',
    'Sterling',
    'Sterling Heights',
    'Steubenville',
    'Stillwater',
    'Stockbridge',
    'Stockton',
    'Stone Mountain',
    'Storm Lake',
    'Stow',
    'Stratford',
    'Streamwood',
    'Streetsboro',
    'Strongsville',
    'Stroudsburg',
    'Stuart',
    'Sudbury',
    'Suffern',
    'Suffolk',
    'Sugar Land',
    'Suitland-Silver Hill',
    'Sulphur',
    'Summerville',
    'Summit',
    'Sumter',
    'Sunbury',
    'Sunnyvale',
    'Sunrise',
    'Surf City',
    'Surprise',
    'Suwanee',
    'Swansea',
    'Swanton',
    'Sykesville',
    'Syracuse',
    'Tacoma',
    'Tallahassee',
    'Tamarac',
    'Tampa',
    'Taos',
    'Tarpon Springs',
    'Tarrytown',
    'Taylor',
    'Taylorsville',
    'Teaneck',
    'Temecula',
    'Tempe',
    'Temple',
    'Terlingua',
    'Texarkana',
    'Texas City',
    'The Colony',
    'The Villages',
    'The Woodlands',
    'Thomasville',
    'Thornton',
    'Thousand Oaks',
    'Three Rivers',
    'Timonium',
    'Tipton',
    'Titusville',
    'Tobyhanna',
    'Toledo',
    'Toms River',
    'Topeka',
    'Torrance',
    'Torrington',
    'Townsend',
    'Towson',
    'Tracy',
    'Traverse City',
    'Trenton',
    'Trinity',
    'Troy',
    'Tualatin',
    'Tucker',
    'Tucson',
    'Tukwila',
    'Tulsa',
    'Tupelo',
    'Tuscaloosa',
    'Tustin',
    'Twentynine Palms',
    'Twin Falls',
    'Twinsburg',
    'Tybee Island',
    'Tyler',
    'U.S. Air Force Academy',
    'Ukiah',
    'Union',
    'Union City',
    'Uniondale',
    'Uniontown',
    'Unity',
    'Universal City',
    'University Place',
    'Upland',
    'Upper Marlboro',
    'Urbana',
    'Utica',
    'Vacaville',
    'Vail',
    'Valdosta',
    'Vallejo',
    'Valley Stream',
    'Valparaiso',
    'Valrico',
    'Vancouver',
    'Vandalia',
    'Venice',
    'Ventura',
    'Vernon',
    'Vernon Hills',
    'Vero Beach',
    'Verona',
    'Vestavia Hills',
    'Victoria',
    'Victorville',
    'Vienna',
    'Villa Rica',
    'Village of Clarkston',
    'Village of Four Seasons',
    'Vineland',
    'Virgilina',
    'Virginia Beach',
    'Virginia City',
    'Visalia',
    'Vista',
    'Voorhees Township',
    'Waco',
    'Wake Forest',
    'Waldorf',
    'Walla Walla',
    'Wallingford',
    'Wallkill',
    'Walnut',
    'Walnut Creek',
    'Waltham',
    'Warminster',
    'Warner Robins',
    'Warren',
    'Warrenton',
    'Warrenville',
    'Warrington',
    'Warsaw',
    'Warwick',
    'Washington',
    'Washington Township',
    'Wasilla',
    'Waskom',
    'Waterbury',
    'Waterford',
    'Waterloo',
    'Watertown',
    'Watford City',
    'Waukegan',
    'Waukesha',
    'Wausau',
    'Wauwatosa',
    'Waxhaw',
    'Wayne',
    'Waynesboro',
    'Waynesville',
    'Weaverville',
    'Weehawken',
    'Weirton',
    'Wellington',
    'Wesley Chapel',
    'West',
    'West Allis',
    'West Babylon',
    'West Bloomfield Township',
    'West Caldwell',
    'West Chester',
    'West Covina',
    'West Des Moines',
    'West Hartford',
    'West Haven',
    'West Hollywood',
    'West Islip',
    'West Jordan',
    'West Lafayette',
    'West Melbourne',
    'West Milford',
    'West Monroe',
    'West New York',
    'West Orange',
    'West Palm Beach',
    'West Sacramento',
    'West Springfield',
    'West Warwick',
    'Westbury',
    'Westerville',
    'Westfield',
    'Westford',
    'Westlake Village',
    'Westland',
    'Westminster',
    'Weston',
    'Westport',
    'Westville',
    'Wexford',
    'Weymouth',
    'Wheaton',
    'Wheeling',
    'White Plains',
    'Whitehall',
    'Whitman',
    'Whittier',
    'Wichita',
    'Wichita Falls',
    'Wildomar',
    'Wilkes-Barre',
    'Williamsburg',
    'Williamsport',
    'Willingboro',
    'Willis',
    'Williston',
    'Wilmette',
    'Wilmington',
    'Wilson',
    'Wilton',
    'Winchester',
    'Winder',
    'Windermere',
    'Windsor',
    'Winnsboro',
    'Winooski',
    'Winston-Salem',
    'Winter Garden',
    'Winter Haven',
    'Winter Park',
    'Winter Springs',
    'Winters',
    'Winthrop',
    'Woburn',
    'Woodbridge',
    'Woodbridge Township',
    'Woodbury',
    'Woodcliff Lake',
    'Woodinville',
    'Woodland',
    'Woodland Park',
    'Woodridge',
    'Woodside',
    'Woodstock',
    'Woonsocket',
    'Worcester',
    'Wylie',
    'Yakima',
    'Yerington',
    'Yonkers',
    'Yorba Linda',
    'York',
    'Yorktown Heights',
    'Yorkville',
    'Young',
    'Youngstown',
    'Youngsville',
    'Ypsilanti',
    'Yuba City',
    'Yucaipa',
    'Yukon',
    'Yuma',
    'Zebulon',
    'Zephyrhills',
    'Zionsville',
  ],
  UK: [
    'Aberdeen',
    'Aberystwyth',
    'Accrington',
    'Aldershot',
    'Altrincham',
    'Antrim',
    'Ardrossan',
    'Ascot',
    'Ashford',
    'Ashton-under-Lyne',
    'Audenshaw',
    'Aylesbury',
    'Ayr',
    'Banbury',
    'Bangor',
    'Barnet',
    'Barnsley',
    'Barry',
    'Basildon',
    'Basingstoke',
    'Bath',
    'Beckenham',
    'Bedford',
    'Belfast',
    'Belper',
    'Berkhamsted',
    'Beverley',
    'Bexhill',
    'Bexleyheath',
    'Biggleswade',
    'Birkenhead',
    'Birmingham',
    "Bishop's Stortford",
    'Blackburn',
    'Blackpool',
    'Blairgowrie',
    'Bolton',
    'Boston',
    'Bournemouth',
    'Bracknell',
    'Bradford',
    'Braintree',
    'Brentford',
    'Brentwood',
    'Bridgend',
    'Bridlington',
    'Brighton',
    'Brighton and Hove',
    'Bristol',
    'Bromley',
    'Bromsgrove',
    'Bude',
    'Burnley',
    'Burton-on-Trent',
    'Bury',
    'Bury St Edmunds',
    'Caerphilly',
    'Camberley',
    'Cambridge',
    'Canterbury',
    'Cardiff',
    'Carlisle',
    'Carmarthen',
    'Carterton',
    'Chatham',
    'Chelmsford',
    'Cheltenham',
    'Chesham',
    'Chester',
    'Chesterfield',
    'Chichester',
    'Chippenham',
    'Chorley',
    'Clacton-on-Sea',
    'Clevedon',
    'Colchester',
    'Congleton',
    'Corby',
    'Coventry',
    'Craigavon',
    'Crawley',
    'Crewe',
    'Crickhowell',
    'Croydon',
    'Dagenham',
    'Darlington',
    'Dartford',
    'Deal',
    'Derby',
    'Dewsbury',
    'Didcot',
    'Diss',
    'Dollar',
    'Doncaster',
    'Dorchester',
    'Dorking',
    'Dudley',
    'Dunbar',
    'Dundee',
    'Dunfermline',
    'Dunkeld',
    'Dunstable',
    'Durham',
    'Eastbourne',
    'Eastleigh',
    'Ebbw Vale',
    'Edgware',
    'Edinburgh',
    'Elgin',
    'Elland',
    'Ely',
    'Enfield',
    'Epsom',
    'Evesham',
    'Exeter',
    'Falkirk',
    'Falmouth',
    'Farnham',
    'Felixstowe',
    'Fernwood',
    'Fleet',
    'Folkestone',
    'Frome',
    'Gateshead',
    'Gillingham',
    'Glasgow',
    'Glossop',
    'Gloucester',
    'Gosport',
    'Gravesend',
    'Grays',
    'Great Malvern',
    'Great Yarmouth',
    'Greenford',
    'Greenock',
    'Grimsby',
    'Guildford',
    'Hailsham',
    'Halifax',
    'Hampton',
    'Harlow',
    'Harrogate',
    'Harrow',
    'Hartlepool',
    'Hassocks',
    'Hastings',
    'Hatfield',
    'Haverfordwest',
    'Hayes',
    'Haywards Heath',
    'Hemel Hempstead',
    'Henley-on-Thames',
    'Hereford',
    'Hertford',
    'High Wycombe',
    'Hitchin',
    'Hockley',
    'Hook',
    'Hornchurch',
    'Horsham',
    'Hounslow',
    'Hove',
    'Huddersfield',
    'Hull',
    'Huntingdon',
    'Ilford',
    'Ipswich',
    'Ireland',
    'Isle of Islay',
    'Kendal',
    'Kenilworth',
    'Kettering',
    'Kilsby',
    "King's Lynn",
    'Kingston upon Hull',
    'Kingston upon Thames',
    'Lanark',
    'Lancaster',
    'Lancing',
    'Leamington Spa',
    'Leeds',
    'Leicester',
    'Leighton Buzzard',
    'Letchworth Garden City',
    'Lewes',
    'Lichfield',
    'Lincoln',
    'Linlithgow',
    'Lisburn',
    'Littlehampton',
    'Liverpool',
    'Livingston',
    'Llandrindod Wells',
    'London',
    'Londonderry',
    'Loughborough',
    'Loughton',
    'Luton',
    'Lymm',
    'Lytham Saint Annes',
    'Lytham St Annes',
    'Macclesfield',
    'Maidenhead',
    'Maidstone',
    'Malvern',
    'Manchester',
    'Margate',
    'Market Harborough',
    'Marlow',
    'Melksham',
    'Middlesbrough',
    'Milton Keynes',
    'Moffat',
    'Montrose',
    'Morden',
    'New Malden',
    'Newbury',
    'Newcastle Emlyn',
    'Newcastle upon Tyne',
    'Newcastle-under-Lyme',
    'Newport',
    'Newquay',
    'Newton Aycliffe',
    'North Shields',
    'Northampton',
    'Northolt',
    'Northwich',
    'Norwich',
    'Nottingham',
    'Nuneaton',
    'Oakham',
    'Okehampton',
    'Oldham',
    'Orpington',
    'Oxford',
    'Paisley',
    'Penrith',
    'Penzance',
    'Perth',
    'Peterborough',
    'Plymouth',
    'Pontypridd',
    'Poole',
    'Portsmouth',
    'Preston',
    'Pulborough',
    'Ramsgate',
    'Rayleigh',
    'Reading',
    'Redditch',
    'Redhill',
    'Reigate',
    'Richmond',
    'Rochester',
    'Romford',
    'Rotherham',
    'Royal Leamington Spa',
    'Royal Tunbridge Wells',
    'Rugby',
    'Runcorn',
    'Saint Helens',
    'Saint Leonards',
    'Sale',
    'Salford',
    'Salisbury',
    'Sandbach',
    'Scarborough',
    'Scunthorpe',
    'Seaford',
    'Selby',
    'Sevenoaks',
    'Sheffield',
    'Shefford',
    'Shepperton',
    'Shoreham-by-Sea',
    'Shrewsbury',
    'Sidcup',
    'Sittingbourne',
    'Sleaford',
    'Slough',
    'Solihull',
    'South Shields',
    'Southall',
    'Southampton',
    'Southend-on-Sea',
    'Southminster',
    'Southport',
    'St Albans',
    'St Austell',
    'St Helens',
    'Stafford',
    'Stamford',
    'Stanmore',
    'Stevenage',
    'Stirling',
    'Stockport',
    'Stockton-on-Tees',
    'Stoke-on-Trent',
    'Stourbridge',
    'Stratford-upon-Avon',
    'Stroud',
    'Sudbury',
    'Sunderland',
    'Surbiton',
    'Sutton',
    'Swansea',
    'Swindon',
    'Taunton',
    'Telford',
    'Thame',
    'Thetford',
    'Torquay',
    'Totnes',
    'Towcester',
    'Truro',
    'Tunbridge Wells',
    'Twickenham',
    'United Downs',
    'Uxbridge',
    'Wakefield',
    'Walsall',
    'Walton-on-Thames',
    'Warrington',
    'Warwick',
    'Waterlooville',
    'Watford',
    'Wellingborough',
    'Welwyn Garden City',
    'Wembley',
    'West Byfleet',
    'Weston-super-Mare',
    'Westonzoyland',
    'Weybridge',
    'Weymouth',
    'Whitehaven',
    'Whitstable',
    'Wigan',
    'Wilmslow',
    'Wincanton',
    'Winchester',
    'Windsor',
    'Winsford',
    'Wirral',
    'Woking',
    'Wokingham',
    'Wolverhampton',
    'Woodbridge',
    'Worcester',
    'Worthing',
    'Wrexham',
    'Yarm',
    'Yeovil',
    'York',
    'Yorkley',
  ],
  AD: ['Andorra la Vella'],
  AE: [
    'Abu Dhabi',
    'Ajman',
    'Al Ain',
    'Dubai',
    'Fujairah',
    'Ras Al-Khaimah',
    'Sharjah',
  ],
  AF: ['Kabul'],
  AG: ["Saint John's"],
  AL: [
    'Durres',
    'Elbasan',
    'Korce',
    'Labinot-Fushe',
    'Prishte',
    'Sarande',
    'Shkoder',
    'Shternen',
    'Tirana',
    'Vlore',
  ],
  AM: ['Gyumri', 'Vanadzor', 'Yerevan'],
  AO: ['Luanda', 'Muene Luanda'],
  AR: [
    'Avellaneda',
    'Bahia Blanca',
    'Belen de Escobar',
    'Benavidez',
    'Berazategui',
    'Bernal',
    'Buenos Aires',
    'Burzaco',
    'Canada de Gomez',
    'Caseros',
    'City Bell',
    'Ciudad de Cordoba',
    'Ciudad de Santa Fe',
    'Concepcion del Uruguay',
    'Cordoba',
    'Corrientes',
    'Del Viso',
    'EOM',
    'Estancia San Ramon',
    'FGL',
    'General Alvear',
    'General Levalle',
    'General Pacheco',
    'General Roca',
    'Godoy Cruz',
    'Guaymallen',
    'Haedo',
    'Ituzaingo',
    'Junin',
    'La Plata',
    'Lanus',
    'Lincoln',
    'Lomas de Zamora',
    'Lujan',
    'Mar del Plata',
    'Martinez',
    'Mendoza',
    'Merlo',
    'Moron',
    'Neuquen',
    'Olavarria',
    'Olivos',
    'Parana',
    'Pergamino',
    'Pilar',
    'Posadas',
    'Quilmes',
    'Ramos Mejia',
    'Resistencia',
    'Rio Ceballos',
    'Rio Grande',
    'Rosario',
    'Salta',
    'San Carlos de Bariloche',
    'San Fernando',
    'San Francisco',
    'San Isidro',
    'San Jose',
    'San Juan',
    'San Luis',
    'San Martin de los Andes',
    'San Miguel',
    'San Miguel de Tucuman',
    'San Nicolas',
    'San Nicolas de Los Arroyos',
    'San Salvador de Jujuy',
    'Santa Fe',
    'Santa Fe de la Vera Cruz',
    'Santa Rosa',
    'Santa Teresita',
    'Santiago del Estero',
    'Santo Tome',
    'Tandil',
    'Temperley',
    'Tigre',
    'Trelew',
    'Ushuaia',
    'Vicente Lopez',
    'Viedma',
    'Villa Allende',
    'Villa Ballester',
    'Villa Carlos Paz',
    'Villa Maria',
  ],
  AT: [
    'Graz',
    'Innsbruck',
    'Linz',
    'Salzburg',
    'Theresienfeld',
    'Vienna',
    'Wiener Neustadt',
  ],
  AU: [
    'Abbotsbury',
    'Adelaide',
    'Arumpo',
    'Ashfield',
    'Auburn',
    'Austral',
    'Australia Plains',
    'Ballarat',
    'Ballarat Central',
    'Banksia Grove',
    'Barangaroo',
    'Bayswater',
    'Bentleigh',
    'Bondi Beach',
    'Bondi Junction',
    'Brisbane',
    'Brisbane City',
    'Broadbeach',
    'Brunswick',
    'Brunswick East',
    'Bundall',
    'Burnside',
    'Byron Bay',
    'Caboolture',
    'Cairns City',
    'Canada Bay',
    'Canberra',
    'Carlton',
    'Carlton North',
    'Carnegie',
    'Carrara',
    'Chippendale',
    'Claremont',
    'Clayton',
    'Clifton Hill',
    'Coburg',
    'Coffs Harbour',
    'Collaroy Plateau',
    'Collingwood',
    'Cremorne',
    'Dandenong',
    'Darwin',
    'Darwin City',
    'Docklands',
    'Erina',
    'Footscray',
    'Fremantle',
    'Galston',
    'Geelong',
    'Ghan',
    'Gladesville',
    'Gold Coast',
    'Gosford',
    'Hamilton',
    'Hawthorn',
    'Hobart',
    'Homebush',
    'Hughesdale',
    'Kensington',
    'Launceston',
    'Little Bay',
    'Loongana',
    'Mackay',
    'Macquarie Park',
    'Manly',
    'Maroochydore',
    'Marrickville',
    'Melbourne',
    'Moorooduc',
    'Mornington',
    'Newcastle',
    'Newtown',
    'Noosa Heads',
    'North Melbourne',
    'North Ryde',
    'North Sydney',
    'Northcote',
    'Nundah',
    'Palm Beach',
    'Parramatta',
    'Penrith',
    'Perth',
    'Point Cook',
    'Preston',
    'Randwick',
    'Redbank Plains',
    'Richmond',
    'Riverton',
    'Saint Lucia',
    'Sydney',
    'South Brisbane',
    'South Melbourne',
    'South Yarra',
    'Southbank',
    'Southport',
    'Springfield Lakes',
    'Strathfield',
    'Summer Hill',
    'Sunshine Coast',
    'Surfers Paradise',
    'Sydney',
    'Telopea',
    'The Ponds',
    'Thornbury',
    'Townsville',
    'Tweed Heads',
    'Tyalgum',
    'Warana',
    'Werribee',
    'West Melbourne',
    'Wollongong',
  ],
  AW: ['Oranjestad'],
  AZ: ['Bakı', 'Baku', 'Баку'],
  BA: [
    'Banja Luka',
    'Bijeljina',
    'Mostar',
    'Sarajevo',
    'Tuzla',
    'Visoko',
    'Zenica',
    'Сарајево',
  ],
  BB: ['Bridgetown'],
  BD: [
    'Ashuganj',
    'Bagerhat',
    'Baraigaon',
    'Barisal',
    'Barishal',
    'Bogra',
    'Bogura',
    'Brahmanbaria',
    'Chandpur',
    'Chapai Nawabganj',
    'Charmonai',
    'Chattogram',
    'Chhatak',
    'Chittagong',
    'Comilla',
    "Cox's Bazar",
    'Cumilla',
    'Dhaka',
    'Dinajpur',
    'Faridpur',
    'Fatikchhari',
    'Feni',
    'Gaibandha',
    'Gazipur',
    'Gopalganj',
    'Habiganj',
    'Jamalpur',
    'Jashore',
    'Jessore',
    'Jhenaidah',
    'Joypurhat',
    'Keraniganj',
    'Keshabpur',
    'Khulna',
    'Khulphadanga Village',
    'Kishoreganj',
    'Kurigram',
    'Kushtia',
    'Lakshmipur',
    'Lalmonirhat',
    'Madhupur',
    'Magura',
    'Manikganj',
    'Meherpur',
    'Mirpur',
    'Mirzapur',
    'Mohammadpur',
    'Moulvibazar',
    'Munshiganj',
    'Mymensingh',
    'Naogaon',
    'Narail',
    'Narayanganj',
    'Narsingdi',
    'Natore',
    'Nawabganj',
    'Netrokona',
    'Nilphamari',
    'Noakhali',
    'Pabna',
    'Panchagarh',
    'Puthia',
    'Rajbari',
    'Rajshahi',
    'Rangamati',
    'Rangpur',
    'Raninagar',
    'Saidpur',
    'Satkhira',
    'Savar',
    'Savar Union',
    'Sherpur',
    'Sirajganj',
    'Sonargaon',
    'Sunamganj',
    'Sylhet',
    'Talimpur',
    'Tangail',
    'Thakurgaon',
    'Tongi',
  ],
  BE: [
    'Aalst',
    'Antwerp',
    'Antwerpen',
    'As',
    'Brugge',
    'Brussel',
    'Brussels',
    'Bruxelles',
    'Charleroi',
    'Courcelles',
    'Etterbeek',
    'Genk',
    'Gent',
    'Ghent',
    'Hasselt',
    'Heist-op-den-Berg',
    'Houthalen-Helchteren',
    'Ixelles',
    'Jabbeke',
    'Kortrijk',
    'Lebbeke',
    'Les Bons Villers',
    'Leuven',
    'Liege',
    'Mechelen',
    'Mons',
    'Namur',
    'Poperinge',
    'Saint-Gilles',
    'Schaerbeek',
    'Sint-Niklaas',
    'Turnhout',
    'Ypres',
  ],
  BF: ['Ouagadougou'],
  BG: [
    'Burgas',
    'Dobrich',
    'Plovdiv',
    'Ruse',
    'Sofia',
    'Stara Zagora',
    'Varna',
    'Veliko Tarnovo',
  ],
  BH: ['Manama'],
  BI: ['Bujumbura'],
  BJ: ['Abomey Calavi', 'Cotonou'],
  BM: ['Hamilton'],
  BN: ['Bandar Seri Begawan'],
  BO: ['Cochabamba', 'La Paz', 'Santa Cruz De La Sierra', 'Sucre', 'Tarija'],
  BR: [
    'Americana',
    'Aracaju',
    'Araraquara',
    'Asa Sul',
    'Balneario Camboriu',
    'Barueri',
    'Bauru',
    'Bela Vista',
    'Belem',
    'Belo Horizonte',
    'Blumenau',
    'Boa Vista',
    'Brasilia',
    'Brusque',
    'Campina Grande',
    'Campinas',
    'Campo Grande',
    'Campos',
    'Campos dos Goytacazes',
    'Canoas',
    'Caruaru',
    'Cascavel',
    'Caxias do Sul',
    'Centro',
    'Conceicao',
    'Cuiaba',
    'Curitiba',
    'Divinopolis',
    'Erechim',
    'Feira de Santana',
    'Florianopolis',
    'Fortaleza',
    'Foz do Iguacu',
    'Franca',
    'Goiania',
    'Guarapuava',
    'Guarulhos',
    'Irani',
    'Itajai',
    'Jaragua do Sul',
    'Joao Pessoa',
    'Joinville',
    'Juiz de Fora',
    'Jundiai',
    'Lajeado',
    'Limeira',
    'Londrina',
    'Cacak',
    'Maceio',
    'Manaus',
    'Marilia',
    'Maringa',
    'Maua',
    'Mogi das Cruzes',
    'Montes Claros',
    'Mossoro',
    'Natal',
    'Niteroi',
    'Novo Hamburgo',
    'Olinda',
    'Osasco',
    'Palhoca',
    'Passo Fundo',
    'Pelotas',
    'Pinhalzinho',
    'Pocos de Caldas',
    'Ponta Grossa',
    'Porto Alegre',
    'Porto Seguro',
    'Praia Grande',
    'Recife',
    'Ribeirao das Neves',
    'Ribeirao Preto',
    'Rio Claro',
    'Rio de Janeiro',
    'Salvador',
    'Santo Andre',
    'Santos',
    'Sao Bernardo do Campo',
    'Sao Carlos',
    'Sao Jose do Rio Preto',
    'Sao Jose dos Campos',
    'Sao Luis',
    'Sao Paulo',
    'Se',
    'Serra',
    'Sorocaba',
    'Teresina',
    'Toledo',
    'Uberlandia',
    'Vila Velha',
    'Vitoria',
    'Volta Redonda',
  ],
  BS: ['Nassau'],
  BT: ['Thimphu'],
  BW: ['Gaborone'],
  BY: ['Brest', 'Gomel', 'Grodno', 'Minsk', 'Vitebsk'],
  BZ: ['Belize City'],
  CA: [
    'Abbotsford',
    'Airdrie',
    'Ajax',
    'Alberta Beach',
    'Alma',
    'Aurora',
    'Ayr',
    'Baden',
    'Banff',
    'Barrie',
    'Beaconsfield',
    'Bedford',
    'Belleville',
    'Blainville',
    'Bolton',
    'Bowmanville',
    'Brampton',
    'Brandon',
    'Brantford',
    'Brockville',
    'Bromont',
    'Brossard',
    'Burlington',
    'Burnaby',
    'Caledonia',
    'Calgary',
    'Cambridge',
    'Cantley',
    'Castlegar',
    'Charlottetown',
    'Chilliwack',
    'Clandeboye',
    'Collingwood',
    'Coquitlam',
    'Corner Brook',
    'Cornwall',
    'Côte Saint-Luc',
    'Dartmouth',
    'Delhi',
    'Delta',
    'Drummondville',
    'Edmonton',
    'Egypt',
    'Fergus',
    'Fort McMurray',
    'Fredericton',
    'Gatineau',
    'Granby',
    'Greater Sudbury',
    'Grimsby',
    'Guelph',
    'Haliburton',
    'Halifax',
    'Hamilton',
    'Innisfil',
    'Kamloops',
    'Kelowna',
    'Kincardine',
    'Kingston',
    'Kirkland',
    'Kitchener',
    'Langley',
    'Langley City',
    'Langley Township',
    'Lansdowne',
    'LaSalle',
    'Laval',
    'Lethbridge',
    'London',
    'Longueuil',
    'Lower Sackville',
    'Markham',
    'Milton',
    'Mission',
    'Mississauga',
    'Moncton',
    'Montreal',
    'Montreal West',
    'Nanaimo',
    'New Glasgow',
    'New Tecumseth',
    'New Westminster',
    'Newmarket',
    'Niagara Falls',
    'North Bay',
    'North Vancouver',
    'Oakville',
    'Oka',
    'Oshawa',
    'Ottawa',
    'Pembroke',
    'Penticton',
    'Peterborough',
    'Pickering',
    'Pinehouse',
    'Pointe-Claire',
    'Port Coquitlam',
    'Quebec',
    'Quebec City',
    'Quinte West',
    'Red Deer',
    'Regina',
    'Revelstoke',
    'Richmond',
    'Richmond Hill',
    'Roslin',
    'Saint John',
    'Sarnia',
    'Saskatoon',
    'Sherbrooke',
    'Sherwood Park',
    'Sidney',
    'Simcoe',
    'Squamish',
    'St. Albert',
    'St. Catharines',
    "St. John's",
    'Steinbach',
    'Stratford',
    'Sudbury',
    'Surrey',
    'Terrace',
    'Thorold',
    'Thunder Bay',
    'Toronto',
    'Trois-Rivieres',
    'Turkey Point',
    'Vancouver',
    'Vaudreuil-Dorion',
    'Vaughan',
    'Vernon',
    'Victoria',
    'Wasaga Beach',
    'Waterloo',
    'Welland',
    'West Vancouver',
    'Whitby',
    'Windsor',
    'Winnipeg',
    'Woodstock',
    'Yarmouth',
  ],
  CD: ['Goma', 'Kinshasa', 'Lubumbashi'],
  CG: ['Brazzaville'],
  CH: [
    'Basel',
    'Bern',
    'Biel',
    'Fribourg',
    'Geneva',
    'Lausanne',
    'Lucerne',
    'Lugano',
    'Neuchatel',
    'Renens',
    'Romoos',
    'Sachseln',
    'St. Gallen',
    'Thun',
    'Vevey',
    'Wil',
    'Winterthur',
    'Zurich',
  ],
  CI: ['Abidjan'],
  CL: [
    'Antofagasta',
    'Buin',
    'Concepcion',
    'Coquimbo',
    'Iquique',
    'La Serena',
    'Las Condes',
    'Los Angeles',
    'Nunoa',
    'Puente Alto',
    'Puerto Montt',
    'Puerto Natales',
    'Santiago',
    'Talca',
    'Temuco',
    'Valdivia',
    'Valparaiso',
    'Vina del Mar',
  ],
  CM: ['Bamenda', 'Buea', 'Douala', 'Yaounde'],
  CN: [
    'Beijing',
    'Dalian',
    'Dandong',
    'Guangzhou',
    'Guangzhou Shi',
    'Hangzhou Shi',
    'Lanzhou Shi',
    'Shanghai',
    'Shenyang',
    'Shenzhen',
  ],
  CO: [
    'Armenia',
    'Barranquilla',
    'Bello',
    'Bogota',
    'Bucaramanga',
    'Buenaventura',
    'Cajica',
    'Cali',
    'Cartagena',
    'Cartagena de Indias',
    'Chia',
    'Cucuta',
    'Dosquebradas',
    'Duitama',
    'Envigado',
    'Ibague',
    'Manizales',
    'Medellin',
    'Neiva',
    'Ocana',
    'Palmira',
    'Pasto',
    'Pereira',
    'Piedecuesta',
    'Popayan',
    'Sabaneta',
    'Santa Marta',
    'Tulua',
    'Tunja',
    'Valledupar',
    'Villavicencio',
  ],
  CR: [
    'Alajuela',
    'Cartago',
    'Curridabat',
    'Heredia',
    'San Jose',
    'San Rafael de Escazu',
  ],
  CU: ['Cienfuegos', 'Havana'],
  CV: ['Praia'],
  CW: ['Willemstad'],
  CY: ['Larnaca', 'Limassol', 'Nicosia', 'Paphos'],
  CZ: [
    'Brno',
    'Ceske Budejovice',
    'Hradec Kralove',
    'Liberec',
    'Olomouc',
    'Ostrava',
    'Pilsen',
    'Prague',
    'Zlin',
  ],
  DE: [
    'Aachen',
    'Augsburg',
    'Berlin',
    'Bielefeld',
    'Bochum',
    'Bonn',
    'Brandenburg an der Havel',
    'Braunschweig',
    'Bremen',
    'Chemnitz',
    'Cologne',
    'Cottbus',
    'Darmstadt',
    'Dessau-Rosslau',
    'Detmold',
    'Dortmund',
    'Dresden',
    'Duisburg',
    'Dusseldorf',
    'Erfurt',
    'Erlangen',
    'Essen',
    'Flensburg',
    'Frankfurt',
    'Frankfurt am Main',
    'Freiburg',
    'Freiburg im Breisgau',
    'Freudenstadt',
    'Gera',
    'Halle (Saale)',
    'Hamburg',
    'Hameln',
    'Hannover',
    'Heidelberg',
    'Hildesheim',
    'Ilmenau',
    'Ingolstadt',
    'Jena',
    'Kaiserslautern',
    'Karlsruhe',
    'Kassel',
    'Kempten',
    'Kiel',
    'Koblenz',
    'Koln',
    'Konstanz',
    'Kunzelsau',
    'Landshut',
    'Leipzig',
    'Leverkusen',
    'Limburg an der Lahn',
    'Ludwigsburg',
    'Magdeburg',
    'Mainz',
    'Mannheim',
    'Marburg',
    'Munich',
    'Munster',
    'Niederdorla',
    'Nuremberg',
    'Oberhausen',
    'Offenburg',
    'Paderborn',
    'Passau',
    'Pfaffenhofen',
    'Pforzheim',
    'Potsdam',
    'Regensburg',
    'Saarbrucken',
    'Sankt Wendel',
    'Sonthofen',
    'Stade',
    'Steinrode',
    'Stuttgart',
    'Tubingen',
    'Ulm',
    'Weimar',
    'Wiesbaden',
    'Worms',
  ],
  DK: [
    'Aalborg',
    'Aarhus',
    'Copenhagen',
    'Esbjerg',
    'Frederiksberg',
    'Herlev',
    'Herning',
    'Holstebro',
    'Kjellerup',
    'Lillered',
    'Skibby',
    'Tilst',
    'Vejle',
    'Viborg',
  ],
  DO: ['La Romana', 'Puerto Plata', 'Santiago', 'Santo Domingo'],
  DZ: [
    'Algiers',
    'Annaba',
    'Batna',
    'Bechar',
    'Bejaia',
    'Birkhadem',
    'Blida',
    'Bordj Bou Arreridj',
    'Bordj El Kiffan',
    'Boumerdes',
    'Cheraga',
    'Constantine',
    'Djasr Kasentina',
    'Draria',
    'El Djazair',
    'El Madania',
    'Hussein Dey',
    'Jijel',
    'Kouba',
    'Medea',
    'Mostaganem',
    'Oran',
    'Oued Chaaba',
    'Relizane',
    'Saida',
    'Setif',
    'Sidi Bel Abbes',
    "Sidi M'Hamed",
    'Skikda',
    'Tizi Ouzou',
    'Tlemcen',
  ],
  EC: [
    'Cuenca',
    'Guayaquil',
    'Ibarra',
    'Latacunga',
    'Loja',
    'Machala',
    'Manta',
    'Portoviejo',
    'Puerto Lopez',
    'Quito',
  ],
  EE: ['Kesklinna', 'Narva', 'Tallinn', 'Tartu', 'Vihtra', 'Voru'],
  EG: [
    '10th of Ramadan City',
    '6th of October City',
    'Alexandria',
    'Aswan',
    'Asyut',
    'Cairo',
    'Damietta',
    'El Sheikh Zayed City',
    'Giza',
    'Hurghada',
    'Ismailia',
    'Kafr El-Shaikh',
    'Khan Younis',
    'Mansoura',
    'Minuf',
    'Minya',
    'Nasr City',
    'New Cairo City',
    'Port Said',
    'Sohag',
    'Tanta',
    'Zagazig',
  ],
  ES: [
    'A Coruna',
    'Adeje',
    'Albacete',
    'Alcala de Henares',
    'Alcobendas',
    'Alcorcon',
    'Alicante',
    'Almeria',
    'Aranjuez',
    'Badajoz',
    'Badalona',
    'Barcelona',
    'Benalmadena',
    'Benidorm',
    'Bilbao',
    'Burgos',
    'Cadiz',
    'Castellon de la Plana',
    'Castellón de la Plana',
    'Castro Urdiales',
    'Chiclana de la Frontera',
    'Ciudad Real',
    'Collado Villalba',
    'Córdoba',
    'Coslada',
    'Cuenca',
    'Dénia',
    'Donostia',
    'Donostia-San Sebastian',
    'Eivissa',
    'El Prat de Llobregat',
    'Elche',
    'Estepona',
    'Ferrol',
    'Fuengirola',
    'Fuenlabrada',
    'Gandia',
    'Getafe',
    'Gijon',
    'Girona',
    'Granada',
    'Guadalajara',
    'Huelva',
    'Huesca',
    'Ibiza',
    'Jaen',
    'Jerez de la Frontera',
    "L'Hospitalet de Llobregat",
    'La Oliva',
    'Las Palmas de Gran Canaria',
    'Las Rozas de Madrid',
    'Leganes',
    'Leon',
    'Lleida',
    'Logrono',
    'Los Realejos',
    'Lugo',
    'Madrid',
    'Majadahonda',
    'Malaga',
    'Manresa',
    'Marbella',
    'Mataro',
    'Merida',
    'Mostoles',
    'Murcia',
    'Navalcarnero',
    'Ourense',
    'Oviedo',
    'Palau-solita i Plegamans',
    'Palma',
    'Pamplona',
    'Paracuellos de Jarama',
    'Pinto',
    'Pontevedra',
    'Pozuelo de Alarcon',
    'Reus',
    'Sabadell',
    'Salamanca',
    'San Sebastian',
    'San Sebastian de los Reyes',
    'Sant Adria de Besos',
    'Sant Celoni',
    'Sant Cugat del Valles',
    'Santa Cruz de Tenerife',
    'Santa Pola',
    'Santander',
    'Santiago de Compostela',
    'Segovia',
    'Sevilla',
    'Sitges',
    'Soller',
    'Talavera de la Reina',
    'Tarifa',
    'Tarragona',
    'Terrassa',
    'Toledo',
    'Torrejon de Ardoz',
    'Torrent',
    'Torrevieja',
    'Tres Cantos',
    'Usansolo',
    'Valencia',
    'Valladolid',
    'Vera',
    'Vic',
    'Vigo',
    'Villanueva de la Serena',
    'Vitoria-Gasteiz',
    'Zaragoza',
  ],
  ET: ['Adama', 'Addis Ababa', 'Bahir Dar', 'Hawassa'],
  FI: [
    'Espoo',
    'Helsinki',
    'Helsinki-Uusimaa',
    'Joensuu',
    'Jyvaskyla',
    'Kuopio',
    'Lahti',
    'Lappeenranta',
    'Oulu',
    'Riihimaki',
    'Rovaniemi',
    'Tampere',
    'Turku',
    'Vaasa',
    'Vantaa',
  ],
  FJ: ['Suva'],
  FR: [
    'Aix-en-Provence',
    'Angers',
    'Anglet',
    'Angouleme',
    'Annecy',
    'Antony',
    'Arcueil',
    'Asnieres-sur-Seine',
    'Avignon',
    'Bayonne',
    'Besancon',
    'Biarritz',
    'Bordeaux',
    'Boulogne-Billancourt',
    'Bourg-la-Reine',
    'Brest',
    'Burdeos',
    'Caen',
    'Cannes',
    'Cenon',
    'Cergy',
    'Clermont-Ferrand',
    'Colombes',
    'Contes',
    'Courbevoie',
    'Courtaboeuf Cedex',
    'Creil',
    'Dijon',
    'Epinay-sur-Seine',
    'Evreux',
    'Foix',
    'Fontainebleau',
    'Francescas',
    'Gravelines',
    'Grenoble',
    'Herblay-sur-Seine',
    'Hericourt',
    'Ivry-sur-Seine',
    'La Rochelle',
    'Le Havre',
    'Le Mans',
    'Le Raincy',
    'Levallois-Perret',
    'Lille',
    'Lyon',
    'Marseille',
    'Metz',
    'Montpellier',
    'Montreuil',
    'Nancy',
    'Nantes',
    'Narbonne',
    'Neuilly-sur-Seine',
    'Nevers',
    'Nice',
    'Nimes',
    'Noisy-le-Grand',
    'Orleans',
    'Pantin',
    'Paris',
    'Pau',
    'Perpignan',
    'Poitiers',
    'Pontault-Combault',
    'Puteaux',
    'Reims',
    'Rennes',
    'Roubaix',
    'Rouen',
    'Saint-Brieuc',
    'Saint-Etienne',
    'Saint-Malo',
    'Saint-Maur-des-Fossés',
    'Saint-Sulpice-Les-Champs',
    'Soissons',
    'Strasbourg',
    'Suresnes',
    'Toulon',
    'Toulouse',
    'Tours',
    'Troyes',
    'Valence',
    'Versailles',
    'Villejuif',
    'Villeurbanne',
    'Vincennes',
    'Vitry-sur-Seine',
  ],
  GA: ['Libreville'],
  GD: ["Saint George's"],
  GN: ['Conarky'],
  GE: ['Batumi', 'Kutaisi', 'Tbilisi'],
  GH: [
    'Accra',
    'Achimota',
    'Adenta Municipality',
    'Cape Coast',
    'Gbawe',
    'Kasoa',
    'Koforidua',
    'Kumasi',
    'Madina',
    'Primbo',
    'Takoradi',
    'Tema',
    'Teshie',
  ],
  GI: ['Gibraltar'],
  GM: ['Banjul'],
  GR: [
    'Agrinio',
    'Alexandroupoli',
    'Athens',
    'Chania',
    'Glifada',
    'Heraklion',
    'Ioannina',
    'Kalamata',
    'Lamia',
    'Larissa',
    'Patras',
    'Thessaloniki',
    'Veria',
    'Volos',
  ],
  GT: [
    'Antigua Guatemala',
    'Ciudad de Guatemala',
    'El Pajonal',
    'Guatemala',
    'Guatemala City',
    'Quezaltenango',
  ],
  GY: ['Georgetown'],
  HK: ['Hong Kong'],
  HN: ['San Pedro Sula', 'Tegucigalpa'],
  HR: [
    'Cakovec',
    'Dubrovnik',
    'Jezerane',
    'Novska',
    'Omis',
    'Osijek',
    'Pula',
    'Rijeka',
    'Samobor',
    'Sibenik',
    'Slavonski Brod',
    'Split',
    'Zadar',
    'Zagreb',
  ],
  HT: ['Port-au-Prince'],
  HU: [
    'Budapest',
    'Debrecen',
    'Eger',
    'Gyor',
    'Kecskemet',
    'Nyiregyhaza',
    'Pecs',
    'Pusztavacs',
    'Szeged',
    'Szombathely',
  ],
  ID: [
    'Balikpapan',
    'Banda Aceh',
    'Bandar Lampung',
    'Bandung',
    'Banjarmasin',
    'Batam',
    'Bekasi',
    'Blitar',
    'Bogor',
    'Central Jakarta',
    'Cianjur',
    'Cibinong',
    'Cilegon',
    'Cimahi',
    'Cirebon',
    'Denpasar',
    'Depok',
    'East Jakarta',
    'Gunung Putri',
    'Indramayu',
    'Jakarta',
    'Jakarta Barat',
    'Jakarta Selatan',
    'Jakarta Timur',
    'Jember',
    'Kediri',
    'Klaten',
    'Kota Bekasi',
    'Kota Semarang',
    'Kupang',
    'Kuta',
    'Lamongan',
    'Lombok',
    'Madiun',
    'Magelang',
    'Makassar',
    'Malang',
    'Manado',
    'Mataram',
    'Medan',
    'Metro',
    'Padang',
    'Palembang',
    'Pekanbaru',
    'Ponorogo',
    'Pontianak',
    'Probolinggo',
    'Purwokerto',
    'Salatiga',
    'Samarinda',
    'Semarang',
    'Serang',
    'Sidoarjo',
    'South Jakarta',
    'South Tangerang',
    'Subang',
    'Sukabumi',
    'Surabaya',
    'Surakarta',
    'Tangerang',
    'Tangerang Selatan',
    'Tasikmalaya',
    'Tegal',
    'Temanggung',
    'Tuban',
    'Tulungagung',
    'Ubud',
    'West Jakarta',
    'Wonosobo',
    'Yogyakarta',
  ],
  IE: [
    'Athlone',
    'Ballina',
    'Blackrock',
    'Bray',
    'Carlow',
    'Cork',
    'Donegal',
    'Dublin',
    'Dublin 1',
    'Dublin 11',
    'Dublin 22',
    'Dublin 24',
    'Dublin 3',
    'Dublin 4',
    'Dublin 6',
    'Dublin 8',
    'Dundalk',
    'Ennis',
    'Galway',
    'Greystones',
    'Kildare',
    'Kilkenny',
    'Killarney',
    'Limerick',
    'Lucan',
    'Monaghan',
    'Mullingar',
    'Naas',
    'Portlaoise',
    'Sligo',
    'Swords',
    'Tipperary',
    'Waterford',
    'Wexford',
    'Wicklow',
  ],
  IL: [
    'Ashkelon',
    "Be'er Sheva",
    "Giv'atayim",
    'Haifa',
    'Herzliya',
    'Jerusalem',
    'Petah Tikva',
    'Ramat Gan',
    'Rishon Letsiyon',
    'Tel Aviv-Jaffa',
    'Tel Aviv-Yafo',
  ],
  IM: ['Isle of Man'],
  IN: [
    'Abohar',
    'Agar',
    'Agartala',
    'Agra',
    'Ahmedabad',
    'Ahmednagar',
    'Aizawl',
    'Ajmer',
    'Akbarpur',
    'Akola',
    'Akot',
    'Alappuzha',
    'Alibag',
    'Aligarh',
    'Alipurduar',
    'Almora',
    'Alwar',
    'Amalapuram',
    'Amaravati',
    'Ambala',
    'Ambala Cantt',
    'Ambedkar Nagar',
    'Ambikapur',
    'Ambikapur Part-X',
    'Amethi',
    'Amravati',
    'Amreli',
    'Amritsar',
    'Amroha',
    'Anand',
    'Anantapur',
    'Andheri',
    'Angalakurichi',
    'Angul',
    'Anjangaon',
    'Ankleshwar',
    'Annasaheb',
    'Anuppur',
    'Araria',
    'Arrah',
    'Asansol',
    'Ashoknagar',
    'Asind',
    'Assagao',
    'Attapur',
    'Auraiya',
    'Aurangabad',
    'Avadi',
    'Ayodhya',
    'Azamgarh',
    'Babai',
    'Badapur',
    'Baddi',
    'Badlapur',
    'Bagalkot',
    'Bagalur',
    'Bageshwar',
    'Baghpat',
    'Bahadurgarh',
    'Bahraich',
    'Baikunthpur',
    'Balaghat',
    'Balangir',
    'Balasore',
    'Ballari',
    'Ballia',
    'Balod',
    'Baloda Bazar',
    'Balotra',
    'Balrampur',
    'Balurghat',
    'Banda',
    'Bandoli',
    'Bandra',
    'Bangaon',
    'Banka',
    'Bankura',
    'Banswara',
    'Barabanki',
    'Baramati',
    'Baramunda',
    'Baran',
    'Barasat',
    'Baraut',
    'Bardez',
    'Bardhaman',
    'Bardoli',
    'Bareilly',
    'Bargarh',
    'Barh',
    'Barhni',
    'Baripada',
    'Barkot',
    'Barmer',
    'Barnala',
    'Barrackpore',
    'Basirhat',
    'Basti',
    'Batala',
    'Bathinda',
    'Bayad',
    'Beawar',
    'Beed',
    'Begusarai',
    'Belagavi',
    'Belgaum',
    'Bengaluru',
    'Berhampore',
    'Betnoti',
    'Bettiah',
    'Betul',
    'Bhabua',
    'Bhadohi Nagar Palika',
    'Bhadrak',
    'Bhagalpur',
    'Bhandara',
    'Bhanohad',
    'Bharatpur',
    'Bharuch',
    'Bhatkal',
    'Bhavnagar',
    'Bhawanipatna',
    'Bhilai',
    'Bhilwara',
    'Bhimavaram',
    'Bhind',
    'Bhiwadi',
    'Bhiwandi',
    'Bhiwani',
    'Bhopal',
    'Bhubaneswar',
    'Bhuj',
    'Bhusawal',
    'Bidar',
    'Bihar',
    'Bihar Sharif',
    'Bihta',
    'Bijnor',
    'Bikaner',
    'Bilaspur',
    'Bilimora',
    'Boisar',
    'Bokaro',
    'Bokaro Steel City',
    'Bolegaon',
    'Bolpur P',
    'Bongaigaon',
    'Borivali',
    'Botad',
    'Brahmapur',
    'Budaun',
    'Budhlada',
    'Budrakh',
    'Bulandshahr',
    'Buldana',
    'Bundi',
    'Burdwan',
    'Burhanpur',
    'Burj Mattewara',
    'Buxar',
    'Chakan',
    'Chakdaha',
    'Chakradharpur',
    'Chalisgaon',
    'Chamba',
    'Champa',
    'Chandannagar',
    'Chandauli',
    'Chandausi',
    'Chandi',
    'Chandigarh',
    'Chandrapur',
    'Chapra',
    'Charkhi Dadri',
    'Charoda',
    'Chatrapur',
    'Chejerla',
    'Chennai',
    'Chhapra',
    'Chhatarpur',
    'Chhatrapati Sambhaji Nagar',
    'Chhatrapati Sambhajinagar (Aurangabad)',
    'Chhichhrana',
    'Chhindwara',
    'Chikhli',
    'Chinna Veerampattinam',
    'Chinsurah',
    'Chiplun',
    'Chirala',
    'Chitradurga',
    'Chittarikkal',
    'Chittoor',
    'Chittorgarh',
    'Chomu',
    'Chopda',
    'Churu',
    'Coimbatore',
    'Contai',
    'Cooch Behar',
    'Cuddalore',
    'Cuttack',
    'Dabha',
    'Dahanu',
    'Dahod',
    'Daltonganj',
    'Daman',
    'Damoh',
    'Darbhanga',
    'Darjeeling',
    'Datia',
    'Dausa',
    'Davanagere',
    'Debipur',
    'Deesa',
    'Degana',
    'Dehradun',
    'Dehri',
    'Delhi',
    'Deoband',
    'Deoghar',
    'Deoria',
    'Dewas',
    'Dhampur',
    'Dhamtari',
    'Dhanbad',
    'Dharamshala',
    'Dharmapuri',
    'Dharwad',
    'Dhenkanal',
    'Dholpur',
    'Dhubri',
    'Dhule',
    'Dibiyapur',
    'Dibrugarh',
    'Didwana',
    'Dighe',
    'Dimapur',
    'Dindigul',
    'Dindori',
    'Dinhata',
    'Diphu',
    'DMC',
    'Dombivli',
    'Doranda',
    'Dumka',
    'Dungarpur',
    'Durg',
    'Durgapur',
    'Dwarka',
    'Eluru',
    'Ernakulam',
    'Erode',
    'Etawah',
    'Faizabad',
    'Faridabad',
    'Faridkot',
    'Farrukhabad',
    'Fatehabad',
    'Fatehpur',
    'Fazilka',
    'Fazilpur Badli',
    'Firozabad',
    'Firozpur',
    'Forbesganj',
    'Fursatganj',
    'Fursungi',
    'Gadarpur',
    'Gadarwara',
    'Gadchiroli',
    'Ganaur',
    'Gandhidham',
    'Gandhinagar',
    'Gandhipuram',
    'Gangapur',
    'Gangarampur',
    'Gangtok',
    'Garh Mukteshwar',
    'Garhwa',
    'Gaya',
    'Ghaziabad',
    'Ghazipur',
    'Giridih',
    'Goa Velha',
    'Godda',
    'Godhra',
    'Gohana',
    'Gola Gokaran Nath',
    'Gonda',
    'Gondal',
    'Gondia',
    'Gopalganj',
    'Gorakhpur',
    'Goregaon',
    'Govindpura',
    'Greater Noida',
    'Gugal Pimpari',
    'Gujrat',
    'Gulbarga',
    'Guna',
    'Guntur',
    'Gurdaspur',
    'Gurugram',
    'Guwahati',
    'Gwalior',
    'Hailakandi',
    'Hajipur',
    'Haldia',
    'Haldwani',
    'Hamirpur',
    'Handia',
    'Hansi',
    'Hanumangarh',
    'Hapur',
    'Hardoi',
    'Hariana',
    'Haridwar',
    'Haryana',
    'Hasnabad',
    'Hassan',
    'Hata',
    'Hathras',
    'Haveri',
    'Hazaribagh',
    'Himatnagar',
    'Hinganghat',
    'Hingoli',
    'Hisar',
    'Hojai',
    'Hooghly',
    'Hosapete',
    'Hoshangabad',
    'Hoshiarpur',
    'Hosur',
    'Howrah',
    'Hubballi',
    'Hubli',
    'Hyderabad',
    'Hyderguda',
    'Ichalkaranji',
    'Idukki',
    'Idukki Township',
    'Imphal',
    'Indiranagara',
    'Indore',
    'Islampur',
    'Itarsi',
    'Jabalpur',
    'Jagadhri',
    'Jagatpura',
    'Jagdalpur',
    'Jagraon',
    'Jaipur',
    'Jajpur',
    'Jalalabad',
    'Jalandhar',
    'Jalaun',
    'Jalgaon',
    'Jalna',
    'Jalore',
    'Jalpaiguri',
    'Jamjodhpur',
    'Jammu',
    'Jamnagar',
    'Jamshedpur',
    'Jamui',
    'Janjgir',
    'Jaora',
    'Jaunpur',
    'Jetpur',
    'Jeypore',
    'Jhajjar',
    'Jhalawar',
    'Jhansi',
    'Jhargram',
    'Jharkhandi',
    'Jharsuguda',
    'Jhunjhunu',
    'Jind',
    'Jodhpur',
    'Jogeshwari',
    'Jorhat',
    'Junagadh',
    'Kadapa',
    'Kadi',
    'Kaithal',
    'Kakinada',
    'Kakkanad',
    'Kalaburagi',
    'Kalanaur',
    'Kalgaon',
    'Kalol',
    'Kalyan',
    'Kalyan-Kongaon',
    'Kalyani',
    'Kangra',
    'Kanker',
    'Kannauj',
    'Kannur',
    'Kanpur',
    'Kapurthala',
    'Karachiya',
    'Karad',
    'Karaikal',
    'Karanja',
    'Karauli',
    'Kardyal',
    'Karimganj',
    'Karimnagar',
    'Karjat',
    'Karli',
    'Karnal',
    'Karur',
    'Karwar',
    'Kasaragod',
    'Kasganj',
    'Kashipur',
    'Kasimpur Power House Colony',
    'Katihar',
    'Katni',
    'Katraj',
    'Kendrapara',
    'Keonjhar',
    'Kerala Estate',
    'Keshod',
    'Khagaria',
    'Khalilabad',
    'Khambhalia',
    'Khambhat',
    'Khamgaon',
    'Khammam',
    'Khandwa',
    'Khanna',
    'Kharagpur',
    'Kharar',
    'Khargone',
    'Khatima',
    'Kheda',
    'Kheri',
    'Khordha',
    'Khunti',
    'Khurai',
    'Khurja',
    'Killa-pardi',
    'Kishanganj',
    'Kochi',
    'kodaly',
    'Koderma',
    'Kohima',
    'Kokrajhar',
    'Kolhapur',
    'Kolkata',
    'Kollam',
    'Kondapur',
    'Kondotty',
    'Kongaon',
    'Korba',
    'Kot Kapura',
    'Kota',
    'Kotdwar',
    'Kottayam',
    'Kovilpatti',
    'Kozhikode',
    'Krishnagiri',
    'Krishnanagar',
    'Kuchaman City',
    'Kudal',
    'Kullu',
    'Kumbakonam',
    'Kumily',
    'Kunda',
    'Kundriya',
    'Kurali',
    'Kurla',
    'Kurnool',
    'Kurukshetra',
    'Kushinagar',
    'Laipham Siphai',
    'Lakhimpur',
    'Lakhisarai',
    'Lalgola',
    'Lalitpur',
    'Latur',
    'Limbdi',
    'Lucknow',
    'Ludhiana',
    'Lunawada',
    'Machilipatnam',
    'Madanapalle',
    'Madgaon',
    'Madhepura',
    'Madhubani',
    'Madhupur',
    'Madikeri',
    'Madurai',
    'Magra',
    'Mahad',
    'Mahamadpur Balmi',
    'Maharajganj',
    'Mahasamund',
    'Mahoba',
    'Mahuva',
    'Maihar',
    'Mainpuri',
    'Majalgaon',
    'Malad',
    'Malappuram',
    'Malda',
    'Malegaon',
    'Malerkotla',
    'Malkapur',
    'Manali',
    'Mancherial',
    'Mandi',
    'Mandi Dabwali',
    'Mandi Gobindgarh',
    'Mandla',
    'Mandsaur',
    'Mandvi',
    'Mangalore',
    'Mangaluru',
    'Mangrol',
    'Manipal',
    'Manjeri',
    'Mansa',
    'Mapusa',
    'Margao',
    'Masanganj',
    'Mathura',
    'Mau',
    'Meerut',
    'Mehsana',
    'Memari',
    'Midnapore',
    'Mira Bhayandar',
    'Miraj',
    'Mirpur',
    'Mirzapur',
    'Mirzapur-cum-Vindhyachal',
    'Mithapur',
    'Modasa',
    'Modinagar',
    'Moga',
    'Mohali',
    'Mohindergarh',
    'Moradabad',
    'Morbi',
    'Morena',
    'Mothooka',
    'Motihari',
    'Mukerian',
    'Mullana',
    'Mumbai',
    'Mundhal',
    'Mundra',
    'Munger',
    'Murshidabad',
    'Murum',
    'Mussoorie',
    'Muzaffarnagar',
    'Muzaffarpur',
    'Mysuru',
    'Nabha',
    'Nadia',
    'Nadiad',
    'Nagaon',
    'Nagapur',
    'Nagar',
    'Nagaur',
    'Nagercoil',
    'Nagina',
    'Nagpur',
    'Nahan',
    'Naigaon',
    'Naihati',
    'Nainital',
    'Nala Sopara',
    'Nalagarh',
    'Namakkal',
    'Nanded',
    'Nanded-Waghala',
    'Nandurbar',
    'Nandyala',
    'Nangal',
    'Naraingarh',
    'Narasaraopeta',
    'Narla',
    'Narnaul',
    'Narsinghpur',
    'Narwana',
    'Nashik',
    'Nasirabad',
    'Naugarh',
    'Naugawan Raitasi',
    'Navalur',
    'Navi Mumbai',
    'Navsari',
    'Nawada',
    'Nawanshahr',
    'Neemuch',
    'Nellore',
    'New Delhi',
    'New Town',
    'Nirsa',
    'Nizamabad',
    'Noida',
    'North Dumdum',
    'Nowgong',
    'Nowrangpur',
    'Nurpur',
    'Odisha',
    'Ongole',
    'Orai',
    'Osmanabad',
    'Pachora',
    'Pachri Para',
    'Padana',
    'Pakhanpur',
    'Palakkad',
    'Palampur',
    'Palanpur',
    'Palghar',
    'Pali',
    'Palia Kalan',
    'Palwal',
    'Panaji',
    'Panchkula',
    'Pandharpur',
    'Pandua',
    'Panipat',
    'Panna',
    'Paonta Sahib',
    'Pappireddipatti',
    'Parbatsar',
    'Parbhani',
    'Patan',
    'Pathanamthitta',
    'Pathankot',
    'Patiala',
    'Patna',
    'Patti',
    'Pauri',
    'Pawti',
    'Perinthalmanna',
    'Perungalathur',
    'Phagwara',
    'Phaltan',
    'Phillaur',
    'Pilani',
    'Pilibhit',
    'Pimpri',
    'Pimpri-Chinchwad',
    'Pinjore',
    'Pithoragarh',
    'Pollachi',
    'Porbandar',
    'Port Blair',
    'Pratapgarh',
    'Prayagraj',
    'Proddatur',
    'Puducherry',
    'Punalur',
    'Pune',
    'Punjab Nagar',
    'Puri',
    'Purnia',
    'Purulia',
    'Pusad',
    'Quepem',
    'R.f.sidh-Ka-Dehra',
    'Radhanpur',
    'Raebareli',
    'Raghogarh',
    'Raichur',
    'Raigad',
    'Raiganj',
    'Raigarh',
    'Raikot',
    'Raipur',
    'Raj Nandgaon',
    'Rajahmundry',
    'Rajamahendravaram',
    'Rajgarh',
    'Rajgurunagar',
    'Rajkot',
    'Rajnandgaon',
    'Rajpura',
    'Rajsamand',
    'Ramgarh Cantonment',
    'Ramnagar',
    'Rampur',
    'Rampurhat',
    'Ranaghat',
    'Rancharda',
    'Ranchi',
    'Ranibandh',
    'Raniganj',
    'Ratangarh',
    'Ratlam',
    'Ratnagiri',
    'Raurkela Industrial Township',
    'Rawatbhata',
    'Rayagada',
    'Renukoot',
    'Rewa',
    'Rewari',
    'Rishikesh',
    'Robertsganj',
    'Rohtak',
    'Roorkee',
    'Rourkela',
    'Rudrapur',
    'Rupnagar',
    'Sagar',
    'Sagwara',
    'Sahai',
    'Saharanpur',
    'Saharsa',
    'Sahibganj',
    'Sahibzada Ajit Singh Nagar',
    'Salem',
    'Samana',
    'Samastipur',
    'Sambalpur',
    'Sambhal',
    'Sangamner',
    'Sangli',
    'Sangli Miraj Kupwad',
    'Sangrur',
    'Sardarshahar',
    'Sasaram',
    'Satara',
    'Satna',
    'Sawai Madhopur',
    'Sector 20B',
    'Secunderabad',
    'Sehore',
    'Seoni',
    'Shahbad',
    'Shahdol',
    'Shahjahanpur',
    'Shahpura',
    'Shamli',
    'Sharanpur',
    'Shegaon',
    'Sheopur',
    'Shikohabad',
    'Shillong',
    'Shimla',
    'Shirdi',
    'Shivamogga',
    'Shivpuri',
    'Shrirampur',
    'Shyamnagar',
    'Sidhi',
    'Sikar',
    'Silchar',
    'Siliguri',
    'Sillod',
    'Silvassa',
    'Simalwara',
    'Singrauli',
    'Sirohi',
    'Sirsa',
    'Sitamarhi',
    'Sitapur',
    'Sitarganj',
    'Sivasagar',
    'Siwan',
    'Sojat',
    'Solan',
    'Solapur',
    'Somnath',
    'Sonarpur',
    'Sonepur',
    'Sonipat',
    'South Dumdum',
    'Sri Ganganagar',
    'Sri Muktsar Sahib',
    'Srikakulam',
    'Srinagar',
    'Sujangarh',
    'Sultanpur',
    'Sumerpur',
    'Supaul',
    'Surat',
    'Suratgarh',
    'Surendranagar',
    'Suri',
    'Tada',
    'Talcher',
    'Tamluk',
    'Tarandale',
    'Tarn Taran Sahib',
    'Tavdi Gaam',
    'Tenkasi',
    'Tezpur',
    'Thane',
    'Thanesar',
    'Thanjavur',
    'Tharad',
    'Thiruvalla',
    'Thiruvananthapuram',
    'Thodupuzha',
    'Thoothukudi',
    'Thrissur',
    'Tijara',
    'Tikamgarh',
    'Tinsukia',
    'Tiruchirappalli',
    'Tirunelveli',
    'Tirupati',
    'Tiruppur',
    'Tirur',
    'Tiruvannamalai',
    'Tohana',
    'Tonk',
    'Tyor',
    'Udaipur',
    'Udayampalayam',
    'Udgir',
    'Udupi',
    'Ujjain',
    'Ukhimath',
    'Ulhasnagar',
    'Una',
    'Unnao',
    'Usaini',
    'Uttarkashi',
    'Uttarpara',
    'Vadasery',
    'Vadodara',
    'Vaishali Nagar',
    'Valsad',
    'Vapi',
    'Varanasi',
    'Vasai-Virar',
    'Vasco da Gama',
    'Vashi',
    'Vellore',
    'Vengurla',
    'Veraval',
    'Vidisha',
    'Vijayapura',
    'Vijayawada',
    'Virar',
    'Visakhapatanam',
    'Visakhapatnam',
    'Visavadar',
    'Visnagar',
    'Vizianagaram',
    'Vrindavan',
    'Wadgaon',
    'Warangal',
    'Wardha',
    'Washim',
    'Wayanad',
    'Yamuna Nagar',
    'Yavatmal',
    'Zirakpur',
  ],
  IQ: ['Baghdad', 'Erbil', 'Sulaymaniyah'],
  IR: [
    'Ahvaz',
    'Amol',
    'Aqda',
    'Esfahan',
    'Gorgan',
    'Isfahan',
    'Karaj',
    'Kashan',
    'Kerman',
    'Mashhad',
    'Qazvin',
    'Qom',
    'Rasht',
    'Sanandaj',
    'Sari',
    'Shiraz',
    'Tabriz',
    'Tehran',
    'Urmia',
    'Yazd',
    'Zanjan',
  ],
  IS: ['Kopavogur', 'Reykjavik'],
  IT: [
    'Acqui Terme',
    'Alessandria',
    'Ancona',
    'Aosta',
    'Arezzo',
    'Arona',
    'Aversa',
    'Bari',
    'Bassano del Grappa',
    'Bergamo',
    'Biella',
    'Bologna',
    'Bolzano',
    'Brescia',
    'Brindisi',
    'Cagliari',
    'Carrara',
    'Caserta',
    'Catania',
    'Catanzaro',
    'Cesena',
    'Chieti',
    'Cittadella',
    'Como',
    'Cosenza',
    'Cremona',
    'Cuneo',
    'Fano',
    'Fermo',
    'Ferrara',
    'Finale Ligure',
    'Firenze',
    'Florence',
    'Fossombrone',
    'Frosinone',
    'Gallarate',
    'Gela',
    'Genoa',
    'Genova',
    'Isola Maggiore',
    "L'Aquila",
    'Lanciano',
    'Lecce',
    'Lecco',
    'Legnano',
    'Livorno',
    'Lucca',
    'Macerata',
    'Mantova',
    'Matera',
    'Messina',
    'Milan',
    'Milano',
    'Modena',
    'Monza',
    'Murillo Fatigati',
    'Naples',
    'Napoli',
    'Novara',
    'Oristano',
    'Ortona',
    'Orvieto',
    'Padova',
    'Padua',
    'Palermo',
    'Parma',
    'Pavia',
    'Perugia',
    'Pesaro',
    'Pescara',
    'Piacenza',
    'Pinerolo',
    'Pisa',
    'Pistoia',
    'Pollenza',
    'Pordenone',
    'Potenza',
    'Prato',
    'Ragusa',
    'Ravenna',
    'Reggio Emilia',
    'Rho',
    'Rimini',
    'Roma',
    'Rome',
    'Salerno',
    'San Benedetto del Tronto',
    'San Giovanni Gemini',
    'Sassari',
    'Schio',
    'Senigallia',
    'Siena',
    'Siracusa',
    'Taranto',
    'Torino',
    'Torrita di Siena',
    'Trapani',
    'Trento',
    'Treviso',
    'Trieste',
    'Turin',
    'Udine',
    'Urbino',
    'Valgreghentino',
    'Varese',
    'Venezia',
    'Venice',
    'Vercelli',
    'Verona',
    'Viareggio',
    'Vicenza',
    'Vigevano',
  ],
  JE: ['Jersey', 'Saint Helier'],
  JM: [
    'Kingston',
    'Mandeville',
    'Montego Bay',
    'Ocho Rios',
    'Portmore',
    'Summerfield',
  ],
  JO: ['Amman', 'Irbid'],
  JP: [
    'Chiba',
    'Chiisagata-gun',
    'Chiyoda City',
    'Fukuoka',
    'Kanazawa',
    'Kawasaki',
    'Koto City',
    'Kyoto',
    'Kyoto-shi',
    'Meguro City',
    'Miki',
    'Minato City',
    'Nagoya',
    'Osaka',
    'Saitama',
    'Shibuya',
    'Shibuya City',
    'Shinagawa City',
    'Shinjuku City',
    'Shinjuku-ku',
    'Shizuoka',
    'Suginami City',
    'Tokyo',
    'Usa',
    'Yokohama',
    'Yokohama-shi',
  ],
  KE: [
    'Archers Post',
    'Chuka',
    'Eldoret',
    'Juja',
    'Kasarani',
    'Kenyatta Road',
    'Kericho',
    'Kiambu',
    'Kisumu',
    'Kitale',
    'Mombasa',
    "Murang'a",
    'Nairobi',
    'Nakuru',
    'Nanyuki',
    'Ngaideithia',
    'Ngong',
    'Nyeri',
    'Ongata Rongai',
    'Ruiru',
    'Starehe',
    'Thika',
  ],
  KG: ['Bishkek'],
  KH: ['Phnom Penh'],
  KN: ['Basseterre'],
  KR: [
    'Busan',
    'Daejeon',
    'Goyang-si',
    'Gwangju',
    'Hongcheon',
    'Seongnam-si',
    'Seoul',
    'Suwon',
  ],
  KW: ['Al Kuwayt', 'Hawally', 'Kuwait City', 'Salmiya'],
  KY: ['George Town'],
  KZ: ['Almaty', 'Astana', 'Nur-Sultan', 'Pavlodar', 'Uralsk'],
  LA: ['Vientiane'],
  LB: [
    'Antelias',
    'Baabda',
    'Batroun',
    'Bayrut',
    'Beirut',
    'Byblos',
    'Jdeideh',
    'Jounieh',
    'Kaslik',
    'Sidon',
    'Tarablus',
    'Tripoli',
    'Tyre',
    'Zahle',
    'Zgharta',
  ],
  LC: ['Castries'],
  LK: [
    'Badulla',
    'Colombo',
    'Dambulla',
    'Dehiwala-Mount Lavinia',
    'Ella',
    'Galle',
    'Gampaha',
    'Ganemulla',
    'Hatton',
    'Homagama',
    'Horana',
    'Jaffna',
    'Kalmunai',
    'Kalutara',
    'Kandana',
    'Kandy',
    'Kegalle',
    'Kuliyapitiya',
    'Kurunegala',
    'Maharagama',
    'Malabe',
    'Matara',
    'Mawanella',
    'Moratuwa',
    'Negombo',
    'Nugegoda',
    'Panadura',
    'Piliyandala',
    'Polonnaruwa',
    'Ratnapura',
    'Seethawakapura',
    'Sri Jayawardenepura Kotte',
    'Vavuniya',
    'Wadduwa',
    'Wattala',
  ],
  LR: ['Monrovia'],
  LS: ['Foso', 'Maseru'],
  LT: ['Balsiai', 'Kaunas', 'Klaipeda', 'Vilnius'],
  LU: ['Luxembourg'],
  LV: ['Riga'],
  LY: ['Benghazi', 'Tarabulus', 'Tripoli'],
  MA: [
    'Agadir',
    'Beni Mellal',
    'Casablanca',
    'Dar-el-Beida',
    'El Jadida',
    'Fes',
    'Kenitra',
    'Khouribga',
    'Marrakech',
    'Marrakesh',
    'Meknes',
    'Ouarzazate',
    'Oujda',
    'Ouled Khellouf',
    'Ouled Yaaakoub',
    'Rabat',
    'Safi',
    'Sale',
    'Settat',
    'Tanger',
    'Tangier',
    'Taroudant',
    'Temara',
    'Tetouan',
  ],
  MC: ['Monaco'],
  MD: ['Chisinau'],
  ME: ['Bar', 'Budva', 'Cetinje', 'Herceg Novi', 'Podgorica', 'Ulcinj'],
  MG: ['Antananarivo', 'Antsirabe', 'Tananarive'],
  MK: [
    'Bitola',
    'Gevgelija',
    'Gostivar',
    'Kavadarci',
    'Kumanovo',
    'Manastiri',
    'Ohrid',
    'Prilep',
    'Shkupi',
    'Shtip',
    'Skopje',
    'Struga',
    'Strumica',
    'Tetovo',
    'Veles',
  ],
  ML: ['Bamako'],
  MM: ['Mandalay', 'Yangon'],
  MN: ['Ulaanbaatar'],
  MQ: ['Fort-de-France'],
  MR: ['Nouakchott'],
  MT: [
    'Birkirkara',
    'Gharb',
    'L-Imsida',
    'La Valeta',
    'Marsaskala',
    'Mgarr',
    'Musta',
    'Naxxar',
    'Sliema',
    "St. Paul's Bay",
    'Swieqi',
    'Valletta',
    'Zurrieq',
  ],
  MU: [
    'Beau Bassin-Rose Hill',
    'Curepipe',
    'Port Louis',
    'Quatre Bornes',
    'Vacoas-Phoenix',
  ],
  MV: ['Male'],
  MW: ['Blantyre', 'Lilongwe', 'Mzuzu', 'Zomba'],
  MX: [
    'Aguascalientes',
    'Ampliación San Mateo',
    'Boca del Río',
    'Calimaya de Diaz Gonzalez',
    'Cancun',
    'Celaya',
    'Centro',
    'Chihuahua',
    'Cholula de Rivadavia',
    'Ciudad Apodaca',
    'Ciudad de Mexico',
    'Ciudad Juarez',
    'Ciudad López Mateos',
    'Ciudad Nezahualcoyotl',
    'Ciudad Obregon',
    'Colima',
    'Cuautitlan Izcalli',
    'Cuernavaca',
    'Culiacan',
    'Culiacan Rosales',
    'Durango',
    'Ecatepec de Morelos',
    'Ensenada',
    'Estado de Mexico',
    'Guadalajara',
    'Guadalupe',
    'Guanajuato',
    'Hermosillo',
    'Heroica Puebla de Zaragoza',
    'Heroica Veracruz',
    'Huixquilucan de Degollado',
    'Irapuato',
    'Jaltipan de Morelos',
    'Jiutepec',
    'Juarez',
    'La Paz',
    'Leon',
    'Leon de los Aldama',
    'Los Mochis',
    'Mazatlan',
    'Mérida',
    'Metepec',
    'Mexicali',
    'Mexico',
    'Mexico City',
    'Mezquitillo',
    'Monterrey',
    'Morelia',
    'Naucalpan de Juarez',
    'Oaxaca',
    'Oaxaca de Juarez',
    'Pachuca',
    'Pachuca de Soto',
    'Playa del Carmen',
    'Puebla',
    'Puebla de Zaragoza',
    'Puerto Vallarta',
    'Reynosa',
    'Salamanca',
    'Saltillo',
    'San Andrés Cholula',
    'San Cristobal de las Casas',
    'San Juan del Río',
    'San Luis Potosi',
    'San Miguel de Allende',
    'San Nicolás de los Garza',
    'San Pedro Garza García',
    'San Pedro Tlaquepaque',
    'Santiago de Queretaro',
    'Sinaloa',
    'Soledad de Graciano Sanchez',
    'Tampico',
    'Tepic',
    'Tijuana',
    'Tlalnepantla',
    'Tlalnepantla de Baz',
    'Tlaxcala de Xicohtencat',
    'Toluca de Lerdo',
    'Torreon',
    'Tultitlan de Mariano Escobedo',
    'Tulum',
    'Tuxtla Gutierrez',
    'Veracruz',
    'Villahermosa',
    'Xalapa',
    'Xalapa-Enriquez',
    'Zapopan',
  ],
  MY: [
    'Alor Setar',
    'Balingian',
    'Bukit Mertajam',
    'Cyberjaya',
    'George Town',
    'Ipoh',
    'Johor Bahru',
    'Kajang',
    'Klang',
    'Kota Bharu',
    'Kota Kinabalu',
    'Kuala Lumpur',
    'Kuantan',
    'Kuching',
    'Malacca',
    'Melaka',
    'Miri',
    'Padang Tengku',
    'Petaling Jaya',
    'Puchong',
    'Rawang',
    'Selangor',
    'Semenyih',
    'Sepang',
    'Seremban',
    'Seri Kembangan',
    'Shah Alam',
    'Skudai',
    'Subang Jaya',
    'Sungai Petani',
  ],
  MZ: ['Beira', 'Maputo'],
  NA: ['Windhoek'],
  NE: ['Niamey'],
  NG: [
    'Aba',
    'Abakaliki',
    'Abeokuta',
    'Abraka',
    'Abuja',
    'Abuja (F.c.t.)',
    'Ado Ekiti',
    'Agege',
    'Akure',
    'Asaba',
    'Awka',
    'Bauchi',
    'Benin City',
    'Calabar',
    'Enugu',
    'Ibadan',
    'Ife',
    'Ikeja',
    'Ikorodu',
    'Ilorin',
    'Iwo',
    'Jos',
    'Jos Plateau',
    'Kaduna',
    'Kaduna South',
    'Kano',
    'Katsina',
    'Kwamba',
    'Lagos',
    'Lekki',
    'Lokoja',
    'Makurdi',
    'Minna',
    'Nnewi',
    'Nsukka',
    'Ogbomosho',
    'Ogbomoso',
    'Onitsha',
    'Osogbo',
    'Ota',
    'Owerri',
    'Port Harcourt',
    'Sagamu',
    'Sokoto',
    'Umuahia',
    'Uyo',
    'Warri',
    'Zaria',
  ],
  NI: ['Managua'],
  NL: [
    "'s-Hertogenbosch",
    'Alkmaar',
    'Almere',
    'Alphen aan den Rijn',
    'America',
    'Amersfoort',
    'Amstelveen',
    'Amsterdam',
    'Apeldoorn',
    'Arnhem',
    'Breda',
    'Brielle',
    'Capelle aan den IJssel',
    'Delft',
    'Den Haag',
    'Deventer',
    'Dordrecht',
    'Ede',
    'Eindhoven',
    'Emmen',
    'Enschede',
    'Ermelo',
    'Gouda',
    'Groningen',
    'Haarlem',
    'Harderwijk',
    'Hilversum',
    'Hoofddorp',
    'Hoorn',
    'Huizen',
    'Leeuwarden',
    'Leiden',
    'Lelystad',
    'Maastricht',
    'Meppel',
    'Naaldwijk',
    'Nijmegen',
    'Ridderkerk',
    'Rijnsburg',
    'Rotterdam',
    'Soest',
    'The Hague',
    'Tilburg',
    'Utrecht',
    'Venlo',
    'Vlaardingen',
    'Wageningen',
    'Zaandam',
    'Zaandijk',
    'Zeist',
    'Zoetermeer',
    'Zwolle',
  ],
  NO: [
    'Alesund',
    'Bergen',
    'Geilo',
    'Haugesund',
    'Kristiansand',
    'Oslo',
    'Sandefjord',
    'Skien',
    'Stavanger',
    'Tonsberg',
    'Trondheim',
  ],
  NP: [
    'Bhaktapur',
    'Bharatpur',
    'Biratnagar',
    'Birgunj',
    'Birtamode',
    'Butwal',
    'Dhangadhi',
    'Gokarneshwor',
    'Itahari',
    'Janakpur',
    'Kathmandu',
    'Kirtipur',
    'Lahan',
    'Lalitpur',
    'Madhyapur Thimi',
    'Nepalgunj',
    'Pokhara',
    'Tansen',
  ],
  NZ: [
    'Auckland',
    'Christchurch',
    'Dunedin',
    'Hamilton',
    'Napier',
    'Nelson',
    'Paraparaumu',
    'Queenstown',
    'Rotorua',
    'Tauranga',
    'Timaru',
    'Wellington',
  ],
  OM: ['Muscat', 'Sohar'],
  PA: ['Panama', 'Panama City'],
  PE: [
    'Arequipa',
    'Barranco',
    'Callao',
    'Cercado De Lima',
    'Chiclayo',
    'Cusco',
    'Distrito de Lima',
    'Lima',
    'Los Olivos',
    'Miraflores',
    'Rímac',
    'San Miguel',
    'Santiago de Surco',
    'Surco',
    'Trujillo',
  ],
  PG: ['Port Moresby'],
  PH: [
    'Alfonso',
    'Alitagtag',
    'Angeles',
    'Angono',
    'Antipolo',
    'Bacolod',
    'Bacoor',
    'Baguio',
    'Batangas',
    'Bay',
    'Binan',
    'Binangonan',
    'Bislig',
    'Bulacan',
    'Bulakan',
    'Butuan City',
    'Cabanatuan City',
    'Cabiao',
    'Cabuyao',
    'Cagayan de Oro',
    'Cainta',
    'Calamba',
    'Calbayog City',
    'Caloocan',
    'Camalig',
    'Capas',
    'Cavite City',
    'Cebu City',
    'Daet',
    'Dagupan',
    'Dapa',
    'Dasmarinas',
    'Davao City',
    'Dipolog City',
    'Dumaguete',
    'General Mariano Alvarez',
    'General Santos City',
    'General Trias',
    'Iba',
    'Iligan City',
    'Iloilo City',
    'Imus',
    'Kawit',
    'La Trinidad',
    'Lapu-Lapu City',
    'Las Pinas',
    'Legazpi City',
    'Lipa',
    'Los Banos',
    'Lucena',
    'Lumban',
    'Mabalacat',
    'Maddela',
    'Majayjay',
    'Makati',
    'Malabon',
    'Malolos',
    'Mandaluyong',
    'Mandaue City',
    'Manila',
    'Marikina',
    'Marilao',
    'Masbate City',
    'Maynila',
    'Mexico',
    'Meycauayan',
    'Municipality of Concepcion',
    'Muntinlupa',
    'Nabunturan',
    'Naga',
    'Navotas',
    'Obando',
    'Olongapo',
    'Ormoc',
    'Ozamiz City',
    'Pagadian City',
    'Panabo',
    'Paranaque',
    'Pasay',
    'Pasig',
    'Puerto Princesa',
    'Quezon',
    'Quezon City',
    'Rodriguez',
    'Sagada',
    'Sampaloc',
    'San Fernando',
    'San Jose',
    'San Jose del Monte City',
    'San Juan',
    'San Mateo',
    'San Pablo',
    'San Pablo City',
    'San Pedro',
    'Santa Cruz',
    'Santa Maria',
    'Santa Rita',
    'Santa Rosa',
    'Santo Tomas',
    'Silang',
    'Surigao City',
    'Tacloban City',
    'Tacurong City',
    'Tagbilaran City',
    'Taguig',
    'Tagum',
    'Tanauan',
    'Tanza',
    'Tarlac City',
    'Taytay',
    'Trece Martires',
    'Tuguegarao City',
    'Tulsa',
    'Urdaneta',
    'Valencia City',
    'Valenzuela',
    'Vigan City',
    'Zamboanga',
  ],
  PK: [
    'Abbottabad',
    'Ahmedpur East',
    'Alipur',
    'Alipur Chatha',
    'Arifwala',
    'Attock',
    'Bahawalnagar',
    'Bahawalnagar District',
    'Bahawalpur',
    'Bannu',
    'Basal',
    'Bhakkar',
    'Bhalwal',
    'Bonga Minhas',
    'Bopalwala',
    'Budhla Sant',
    'Bughlani',
    'Burewala',
    'Chakwal',
    'Charsadda',
    'Chenab Nagar',
    'Chichawatni',
    'Chiniot',
    'Chishtian',
    'Chitral',
    'Chowk Azam',
    'Chunian',
    'D G Khan',
    'Darya Khan',
    'Daska',
    'Depalpur',
    'Dera Ghazi Khan',
    'Dera Ismail Khan',
    'Dina',
    'Dir Lower',
    'Eminabad',
    'Faisalabad',
    'Farid Abad',
    'Farooqabad',
    'Fort Abbas',
    'Ghotki',
    'Ghurki',
    'Girdu',
    'Gojra',
    'Goth Brohi Rahim Bux',
    'Gujar Khan',
    'Gujranwala',
    'Gujrat',
    'Gulberg',
    'Gulistan',
    'Gulshan Iqbal',
    'Hafizabad',
    'Haripur',
    'Haroonabad',
    'Hasilpur',
    'Hassan Abdal',
    'Haveli Lakha',
    'Havelian',
    'Hazro',
    'Hyderabad',
    'Islamabad',
    'Jahanian',
    'Jalsai',
    'Jampur',
    'Jamshoro',
    'Jaranwala',
    'Jauharabad',
    'Jhang',
    'Jhang Sadar',
    'Jhelum',
    'Kahror Pakka',
    'Kahuta',
    'Kamalia',
    'Kamoke',
    'Karachi',
    'Karor Lal Esan',
    'Kasur',
    'Khairpur',
    'Khanewal',
    'Khanpur',
    'Kharian',
    'Khipro',
    'Khudian Khas',
    'Khushab',
    'Kohat',
    'Kot Radha Kishan',
    'Lahore',
    'Lahore DHA',
    'Lakki Marwat',
    'Lalamusa',
    'Larkana',
    'Layyah',
    'Lodhran',
    'Mandi Bahauddin',
    'Mandwal',
    'Mansehra',
    'Mardan',
    'Mian Channu',
    'Mianwali',
    'Mingora',
    'Mir Ali Mirali',
    'Mirpur Khas',
    'Mithi',
    'Model Town',
    'Multan',
    'Murree',
    'Muzaffargarh',
    'Nabipur',
    'Nankana Sahib',
    'Narowal',
    'Nawabshah',
    'Nowshera',
    'Okara',
    'Pakpattan',
    'Pasrur',
    'Peshawar',
    'Pir Mahal',
    'Qaziabad',
    'Quetta',
    'Rahim Yar Khan',
    'Rahwali Cantonments',
    'Raiwind',
    'Rajanpur District',
    'Rawalpindi',
    'Renala Khurd',
    'Sadiqabad',
    'Sahiwal',
    'Sambrial',
    'Samina',
    'Samundri',
    'Sarai Alamgir',
    'Sargodha',
    'Sdk',
    'Shah Faisal Town',
    'Shahdadpur',
    'Shahdara',
    'Shangla',
    'Sharafi Goth',
    'Sheikhupura',
    'Sialkot',
    'Sukkur',
    'Swabi',
    'Swat',
    'Talagang',
    'Tando Adam',
    'Tando Allahyar',
    'Tarhana',
    'Taunsa',
    'Taxila',
    'Toba Tek Singh',
    'Ugoke',
    'Ugoki',
    'Vehari',
    'Wah',
    'Wah Cantt',
    'Wazirabad',
    'Yazman Mandi',
    'کیته',
  ],
  PL: [
    'Bialystok',
    'Bielsko-Biala',
    'Brudzen Duzy',
    'Bydgoszcz',
    'Czestochowa',
    'Gdansk',
    'Gdynia',
    'Katowice',
    'Kielce',
    'Krakow',
    'Leszno',
    'Lublin',
    'Lodz',
    'Olsztyn',
    'Poznan',
    'Rybnik',
    'Rzeszow',
    'Skorka',
    'Szczecin',
    'Tarnow',
    'Torun',
    'Turek',
    'Walbrzych',
    'Warsaw',
    'Warszawa',
    'Wroclaw',
    'Zielona Gora',
  ],
  PR: [
    'Barceloneta',
    'Bayamon',
    'Caguas',
    'Carolina',
    'Guaynabo',
    'Luquillo',
    'Orocovis',
    'Ponce',
    'San Juan',
    'Toa Alta',
    'Toa Baja',
  ],
  PT: [
    'Albufeira',
    'Alcobaca',
    'Almada',
    'Amadora',
    'Aveiro',
    'Barcelos',
    'Barreiro',
    'Braga',
    'Caldas da Rainha',
    'Carregal do Sal',
    'Cascais',
    'Chamusca',
    'Charneca da Caparica',
    'Coimbra',
    'Covilha',
    'Ericeira',
    'Espinho',
    'Estoril',
    'Evora',
    'Faro',
    'Figueira da Foz',
    'Funchal',
    'Guarda',
    'Guimaraes',
    'Lagos',
    'Leiria',
    'Lisboa',
    'Lisbon',
    'Mafra',
    'Maia',
    'Mangualde',
    'Matosinhos',
    'Odivelas',
    'Oeiras',
    'Olhao',
    'Oporto',
    'Peniche',
    'Ponta Delgada',
    'Portimao',
    'Porto',
    'Povoa de Varzim',
    'Queluz',
    'Rio Tinto',
    'Santarem',
    'Sao Joao da Madeira',
    'Sao Miguel do Rio Torto',
    'Sesimbra',
    'Setubal',
    'Sintra',
    'Torres Vedras',
    'Vale de Cambra',
    'Valongo',
    'Viana do Castelo',
    'Vila do Conde',
    'Vila Nova de Famalicao',
    'Vila Nova de Gaia',
    'Vila Real',
    'Viseu',
  ],
  PY: ['Asuncion'],
  QA: ['Doha'],
  RE: ['Saint Pierre'],
  RO: [
    'Arad',
    'Bacau',
    'Baia Mare',
    'Bistrita',
    'Botosani',
    'Braila',
    'Brasov',
    'Bucharest',
    'Cluj-Napoca',
    'Constanta',
    'Craiova',
    'Galati',
    'Iasi',
    'Jibert',
    'Miercurea Ciuc',
    'Oradea',
    'Ploiesti',
    'Satu Mare',
    'Sibiu',
    'Sighetu Marmatiei',
    'Suceava',
    'Targu Mures',
    'Timisoara',
    'Vaslui',
  ],
  RS: [
    'Belgrade',
    'Beograd',
    'Čačak',
    'Indija',
    'Jabucje',
    'Kikinda',
    'Kragujevac',
    'Kraljevo',
    'Kruševac',
    'Leskovac',
    'Maršić',
    'Niš',
    'Novi Sad',
    'Obrenovac',
    'Pančevo',
    'Šabac',
    'Smederevo',
    'Sombor',
    'Subotica',
    'Užice',
    'Vršac',
    'Zrenjanin',
  ],
  SC: ['Victoria'],
  RU: [
    'Barnaul',
    'Belgorod',
    'Cheboksary',
    'Chelyabinsk',
    'Irkutsk',
    'Izhevsk',
    'Kaliningrad',
    'Kazan',
    'Kemerovo',
    'Khabarovsk',
    'Krasnodar',
    'Krasnoyarsk',
    'Kursk',
    'Moscow',
    'Moskva',
    'Nizhnij Novgorod',
    'Novorossiysk',
    'Novosibirsk',
    'Omsk',
    'Petrozavodsk',
    'Rostov',
    'Saint Petersburg',
    'Samara',
    'Sankt-Peterburg',
    'Sochi',
    'Vladivostok',
    'Volgograd',
    'Voronez',
    'Yaroslavl',
    'Yekaterinburg',
  ],
  RW: ['Kigali'],
  SA: [
    'Abha',
    'Al Hofuf',
    'Al Khobar',
    'Dammam',
    'Dhahran',
    'Jeddah',
    'Madinah',
    'Makkah',
    'Mecca',
    'Medina',
    'Riyadh',
    'Tabuk',
  ],
  SD: ['Al Khurtum', 'Khartoum'],
  SE: [
    'Angelholm',
    'Boras',
    'Bromma',
    'Falkenberg',
    'Goteborg',
    'Gothenburg',
    'Halmstad',
    'Helsingborg',
    'Herrang',
    'Jonkoping',
    'Karlstad',
    'Kavlinge',
    'Landskrona',
    'Linkoping',
    'Lund',
    'Malmo',
    'Mellerud',
    'Norrkoping',
    'Offerdal',
    'Orebro',
    'Pitea',
    'Skelleftea',
    'Sodertalje',
    'Stockholm',
    'Sundsvall',
    'Taby',
    'Umea',
    'Uppsala',
    'Vanersborg',
    'Vasteras',
    'Vaxjo',
  ],
  SG: ['Singapore'],
  SI: ['Celje', 'Hrastnik', 'Koper', 'Kranj', 'Ljubljana', 'Maribor', 'Rodez'],
  SK: [
    'Bratislava',
    'Cierny Balog',
    'Kosice',
    'Poprad',
    'Presov',
    'Trencin',
    'Valaska',
  ],
  SL: ['Freetown'],
  SN: ['Dakar'],
  SO: ['Hargeisa', 'Mogadishu', 'Muqdisho'],
  SR: ['Paramaribo'],
  SS: ['Juba'],
  SV: ['Aqua Zarca', 'La Libertad', 'San Salvador', 'Santa Tecla'],
  SY: ['Aleppo', 'Damascus', 'Homs', 'Latakia', 'Tartus'],
  SZ: ['Manzini', 'Mbabane'],
  TG: ['Lome', 'Togoville'],
  TH: [
    'Bangkok',
    'Chiang Mai',
    'Khet Phra Nakhon',
    'Koh Samui',
    'Nakhon Pathom',
    'Nonthaburi',
    'Pattaya City',
    'Phra Nakhon',
    'Phu Nam Yot',
    'Phuket',
    'Samrong',
    'Si Phum',
    'Si Racha',
    'Tambon Nong Chaeng',
  ],
  TM: ['Ashgabat'],
  TN: [
    'Ariana',
    'Ben Arous',
    'Ben Ghilouf',
    'Bizerte',
    'Carthage',
    'Franceville',
    'Gammarth',
    'Hammamet',
    'Manouba',
    'Monastir',
    'Nabeul‎',
    'Sfax',
    'Sousse',
    'Tunis',
  ],
  TR: [
    'Adana',
    'Ankara',
    'Antalya',
    'Aydin',
    'Balikesir',
    'Bandirma',
    'Bursa',
    'Denizli',
    'Eskisehir',
    'Fethiye',
    'Gaziantep',
    'Iskenderun',
    'Isparta',
    'Istanbul',
    'Izmir',
    'Izmit',
    'Kayseri',
    'Konya',
    'Kusadasi',
    'Kutahya',
    'Manisa',
    'Marmaris',
    'Mersin',
    'Mugla',
    'Pamukkale',
    'Sakarya',
    'Samsun',
    'Trabzon',
    'Turkiye Petrolleri',
    'Usak',
  ],
  TT: ['Arima', 'Chaguanas', 'Port of Spain', 'San Fernando', 'Tunapuna'],
  TW: ['Kaohsiung', 'Taipei'],
  TZ: ['Arusha', 'Dar es Salaam', 'Dodoma', 'Mwanza', 'Tabora', 'Usa River'],
  UA: [
    'Cherkasy',
    'Chernihiv',
    'Chernivtsi',
    'Dnipro',
    'Dnipropetrovsk',
    'Dobrovelychkivka',
    'Ivano-Frankivsk',
    'Kamianske',
    'Kharkiv',
    'Kherson',
    'Khmelnytskyi',
    'Kryvyi Rih',
    'Kyiv',
    'Lutsk',
    'Lviv',
    'Mukacheve',
    'Mykolaiv',
    'Odesa',
    'Odessa',
    'Poltava',
    'Rivne',
    'Ternopil',
    'Ukrainka',
    'Uzhhorod',
    'Vinnytsia',
    'Zaporizhzhia',
  ],
  UG: ['Kampala', 'Lugazi'],
  UY: [
    'Canelones',
    'Ciudad de la Costa',
    'Colonia del Sacramento',
    'Montevideo',
    'Punta del Este',
  ],
  UZ: ['Tashkent'],
  VC: ['Georgetown'],
  VE: [
    'Altagracia',
    'Anaco',
    'Barcelona',
    'Barquisimeto',
    'Cabimas',
    'Cabudare',
    'Caracas',
    'Ciudad Bolívar',
    'Ciudad Guayana',
    'Coro',
    'El Membrillo',
    'El Tigre',
    'La Guaira',
    'Lechería',
    'Los Teques',
    'Maiquetía',
    'Maracaibo',
    'Maracay',
    'Maturin',
    'Merida',
    'Porlamar',
    'Puerto La Cruz',
    'Punto Fijo',
    'Rubio',
    'San Antonio de Los Altos',
    'San Cristobal',
    'San Diego',
    'Valencia',
  ],
  VI: ["Anna's Retreat", 'Christiansted'],
  VN: [
    'Da Nang',
    'Hanoi',
    'Hai Duong',
    'Ho Chi Minh City',
    'Nha Trang',
    'Vung Tau',
  ],
  XK: [
    'Pristina',
    'Prizren',
    'Ferizaj',
    'Gjilan',
    'Peja',
    'Gjakova',
    'Podujevo',
    'Mitrovica',
    'Fushe Kosove',
    'Vushtrri',
  ],
  YE: ['Sanaa'],
  ZA: [
    'Alberton',
    'Auckland',
    'Ballito',
    'Benoni',
    'Berea',
    'Bloemfontein',
    'Boksburg',
    'Cape Town',
    'Centurion',
    'Delmas',
    'Dolphin Coast',
    'Durban',
    'Durban North',
    'East London',
    'Edenvale',
    'Ennerdale',
    'Gansbaai',
    'George',
    'Germiston',
    'Gqeberha',
    'Hartbeespoort',
    'Johannesburg',
    'Johannesburg South',
    'Joubertina',
    'Kempton Park',
    'Kimberley',
    'Klerksdorp',
    'Knysna',
    'KwaDukuza',
    'Letsitele',
    'Louis Trichardt',
    'Malmesbury',
    'Mbombela',
    'Middelburg',
    'Midrand',
    'Mpumalanga',
    'Paarl',
    'Pietermaritzburg',
    'Pinetown',
    'Plettenberg Bay',
    'Polokwane',
    'Port Elizabeth',
    'Potchefstroom',
    'Pretoria',
    'Queenstown',
    'Randburg',
    'Richards Bay',
    'Roodepoort',
    'Roodepoort 302-Iq',
    'Rustenburg',
    'Sandton',
    'Soweto',
    'Stellenbosch',
    'Vanderbijlpark',
    'Vosloorus',
    'Wellington',
  ],
  ZM: ['Kitwe', 'Lusaka', 'Ndola'],
  ZW: ['Bulawayo', 'Harare'],
};

export { countries, citiesByCountries };
